
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
  ArcElement
} from "chart.js";

/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import TaskList from "./TaskList";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate, useLocation } from "react-router-dom";
import MemberStageRing from "../../components/userRing/MemberStageRing";
import { apiRequest, stageAPI, tasksAPI } from "../../api/apiHelper";
import {
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import Menu from '@mui/material/Menu';
import CustomFilterBar, { DATE_OPTIONS } from "../../components/userRing/CustomFilterBar";
import TeleSalesReport from "./TeleSalesReport";
import { Bar } from "react-chartjs-2";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DownloadIcon from "@mui/icons-material/Download";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
// If you have a utility for CSV download, import it here:
// import downloadChartCSV from "../../utils/downloadChartCSV";
// If stringToColor is used, ensure it's defined or imported.

// Lightweight CSV download helper used by chart buttons.
const downloadChartCSV = (chartData = {}, opts = {}) => {
  const { filename = 'chart_data.csv' } = opts;
  try {
    const labels = chartData.labels || [];
    const datasets = Array.isArray(chartData.datasets) ? chartData.datasets : [];

    // Build header
    const header = ['label', ...datasets.map((ds) => ds.label || 'dataset')];

    // Build rows by index
    const rows = labels.map((lab, i) => {
      const row = [lab];
      datasets.forEach((ds) => {
        const v = Array.isArray(ds.data) ? ds.data[i] : '';
        row.push(v != null ? v : '');
      });
      return row;
    });

    // If no labels, try datasets length
    if (!labels.length && datasets.length && datasets[0].data) {
      const maxLen = Math.max(...datasets.map((d) => (Array.isArray(d.data) ? d.data.length : 0)));
      for (let i = 0; i < maxLen; i++) {
        const row = [String(i + 1)];
        datasets.forEach((ds) => {
          const v = Array.isArray(ds.data) ? ds.data[i] : '';
          row.push(v != null ? v : '');
        });
        rows.push(row);
      }
    }

    const csv = [header, ...rows].map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (e) {
    console.error('downloadChartCSV failed', e);
  }
};

const initialSourcesChartData = {
  labels: [],
  datasets: [
    {
      label: "Leads by Source",
      data: [],
      backgroundColor: [],
      borderWidth: 0,
      maxBarThickness: 25,
    },
  ],
};
const sourcesChartOptions = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      mode: "nearest",
      intersect: true,
      callbacks: {
        label: function (context) {
          return context.label + ': ' + context.parsed.x + ' leads';
        }
      }
    }
  },
  scales: {
    x: {
      beginAtZero: true,
      title: {
        display: true,
        text: 'Number of Leads →',
        font: { size: 13, weight: 'normal' },
        color: '#666',
        padding: { top: 10, bottom: 5 }
      },
      ticks: {
        stepSize: 1,
        font: { size: 12, weight: 'normal' },
        maxTicksLimit: 8,
        autoSkip: true
      },
      grid: { color: 'rgba(0,0,0,0.05)' }
    },
    y: {
      title: {
        display: true,
        text: 'Lead Sources →',
        font: { size: 13, weight: 'normal' },
        color: '#666',
        padding: { left: 20, right: 15 }
      },
      ticks: { font: { size: 12, weight: 'normal' } },
      grid: { display: false }
    },
  },
  elements: {
    bar: { borderRadius: 0, borderSkipped: false },
  },
};

// Team tasks chart data is prepared inside the component using fetched data

// color helper: deterministic color from string
const stringToColor = (str = "") => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
  const r = (hash >> 0) & 0xff;
  const g = (hash >> 8) & 0xff;
  const b = (hash >> 16) & 0xff;
  // ensure visible range
  return `rgb(${(Math.abs(r) % 150) + 60}, ${(Math.abs(g) % 150) + 60}, ${(Math.abs(b) % 150) + 60})`;
};

// lightweight color palette helper — use stringToColor directly where needed

// Funnel chart options (used by Overall Lead Funnel)
const funnelChartOptions = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: function (context) {
          return context.dataset.actualValues[context.dataIndex] + ' leads';
        }
      }
    }
  },
  scales: {
    x: {
      beginAtZero: true,
      title: {
        display: true,
        text: 'Number of Leads →',
        font: { size: 13, weight: 'normal' },
        color: '#666',
        padding: { top: 10, bottom: 5 }
      },
      ticks: {
        stepSize: 10,
        font: { size: 12, weight: 'normal' }
      },
      grid: { color: 'rgba(0,0,0,0.05)' }
    },
    y: {
      title: {
        display: true,
        text: 'Sales Stages →',
        font: { size: 13, weight: 'normal' },
        color: '#666',
        padding: { left: 20, right: 15 }
      },
      ticks: { font: { size: 12, weight: 'normal' } },
      grid: { display: false }
    },
  },
};

// Stage-user chart options (used inside stage modal)
const stageUserChartOptions = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: function (context) {
          return context.dataset.actualValues[context.dataIndex] + ' items';
        }
      }
    }
  },
  scales: {
    x: {
      beginAtZero: true,
      title: {
        display: true,
        text: 'Number of Items →',
        font: { size: 13, weight: 'normal' },
        color: '#666',
        padding: { top: 10, bottom: 5 }
      },
      ticks: {
        stepSize: 5,
        font: { size: 12, weight: 'normal' }
      },
      grid: { color: 'rgba(0,0,0,0.05)' }
    },
    y: {
      title: {
        display: true,
        text: 'Team Members →',
        font: { size: 13, weight: 'normal' },
        color: '#666',
        padding: { left: 20, right: 15 }
      },
      ticks: { font: { size: 12, weight: 'normal' } },
      grid: { display: false }
    },
  },
};

// Team performance chart options
const teamPerfChartOptions = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: "top", labels: { boxWidth: 12, font: { size: 12, weight: 'normal' } } },
    tooltip: {
      callbacks: {
        label: function (context) {
          return context.dataset.label + ': ' + (context.dataset.actualValues?.[context.dataIndex] || context.raw);
        }
      }
    },
    datalabels: {
      display: false
    }
  },
  scales: {
    x: {
      stacked: true,
      beginAtZero: true,
      title: {
        display: true,
        text: 'Number of Deals →',
        font: { size: 13, weight: 'normal' },
        color: '#666',
        padding: { top: 10, bottom: 5 }
      },
      ticks: {
        stepSize: 1,
        font: { size: 12, weight: 'normal' }
      },
      grid: { color: 'rgba(0,0,0,0.05)' }
    },
    y: {
      stacked: true,
      title: {
        display: true,
        text: 'Team Members →',
        font: { size: 13, weight: 'normal' },
        color: '#666',
        padding: { left: 25, right: 15 }
      },
      ticks: {
        font: { size: 12, weight: 'normal' },
        padding: 8,
        maxRotation: 0,
        minRotation: 0
      },
      grid: { display: false }
    },
  },
  elements: {
    bar: { borderRadius: 0, borderSkipped: false, barThickness: 18 }
  }
};

// ===== ADD: initial funnel fallback state =====
const initialFunnelChartState = {
  labels: [],
  datasets: [
    {
      label: "Overall Lead Funnel",
      data: [],
      actualValues: [],
      backgroundColor: [],
      borderWidth: 0,
      barThickness: 24,
    },
  ],
};
// ===== END ADD =====

// Professional calendar dropdown filter for charts (inline custom range — same as UserDetails)
const ChartDateFilter = ({ value, onChange, anchorEl, setAnchorEl, menuId }) => {
  const quickFilters = [
    { label: "All Time", value: "" },
    { label: "Last 7 Days", value: "7" },
    { label: "Last 30 Days", value: "30" },
    { label: "Last 90 Days", value: "90" }
  ];
  const [showCustom, setShowCustom] = useState(() =>
    value && typeof value === 'object' && value.startDate && value.endDate
  );
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [dateError, setDateError] = useState("");

  const handleClose = () => {
    setShowCustom(false);
    setAnchorEl(null);
  };

  const handleSelect = (filterValue) => {
    onChange(filterValue);
    handleClose();
  };

  const isCustomActive = value && typeof value === 'object' && value.startDate && value.endDate;

  return (
    <Menu
      id={menuId}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      PaperProps={{
        style: {
          minWidth: 220,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          borderRadius: 8,
          padding: 4,
        }
      }}
    >
      {quickFilters.map((filter) => (
        <div
          key={filter.value}
          onClick={() => handleSelect(filter.value)}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            fontWeight: (!isCustomActive && value === filter.value) ? 600 : 400,
            backgroundColor: (!isCustomActive && value === filter.value) ? "#f5f5f5" : "transparent",
            color: (!isCustomActive && value === filter.value) ? "#1976d2" : "#333",
            cursor: "pointer",
            transition: "all 0.2s",
            borderLeft: (!isCustomActive && value === filter.value) ? "3px solid #1976d2" : "3px solid transparent",
          }}
          onMouseEnter={(e) => { if (value !== filter.value) e.currentTarget.style.backgroundColor = "#f9f9f9"; }}
          onMouseLeave={(e) => { if (value !== filter.value) e.currentTarget.style.backgroundColor = "transparent"; }}
        >
          {filter.label}
        </div>
      ))}

      <div style={{ height: 1, backgroundColor: '#eee', margin: '6px 8px' }} />

      <div
        onClick={() => setShowCustom(true)}
        style={{
          padding: "8px 12px",
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: isCustomActive ? '#f5f5f5' : 'transparent',
          borderLeft: isCustomActive ? '3px solid #1976d2' : '3px solid transparent',
        }}
      >
        <div style={{ fontSize: 14, fontWeight: isCustomActive ? 600 : 500 }}>Custom Range</div>
        <div style={{ fontSize: 12, color: '#666' }}>{isCustomActive ? `${value.startDate} → ${value.endDate}` : '…'}</div>
      </div>

      {showCustom && (
        <div style={{ padding: '8px 12px', display: 'flex', flexDirection: 'column', gap: 8 }} onClick={(e) => e.stopPropagation()}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <input
              type="date"
              value={customStart}
              onChange={(e) => { setCustomStart(e.target.value); setDateError(""); }}
              style={{ flex: 1, padding: '6px 8px', marginBottom: 6 }}
              placeholder="Start date"
            />
            <input
              type="date"
              value={customEnd}
              onChange={(e) => { setCustomEnd(e.target.value); setDateError(""); }}
              style={{ flex: 1, padding: '6px 8px', marginBottom: 6 }}
              placeholder="End date"
            />
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
              <button onClick={() => setShowCustom(false)} style={{ padding: '6px 12px', cursor: 'pointer' }}>Cancel</button>
              <button
                onClick={() => {
                  if (!customStart || !customEnd) { setDateError('Please select both dates.'); return; }
                  const start = new Date(customStart);
                  const end = new Date(customEnd);
                  if (end < start) { setDateError('End date cannot be before start date.'); return; }
                  setDateError("");
                  onChange({ startDate: customStart, endDate: customEnd });
                  handleClose();
                }}
                disabled={!customStart || !customEnd}
                style={{
                  padding: '6px 12px',
                  background: (!customStart || !customEnd) ? '#aaa' : '#1976d2',
                  color: '#fff', border: 'none',
                  cursor: (!customStart || !customEnd) ? 'not-allowed' : 'pointer',
                }}
              >Apply</button>
            </div>
            {dateError && <div style={{ color: 'red', fontSize: 12, marginTop: 4 }}>{dateError}</div>}
          </div>
        </div>
      )}
    </Menu>
  );
};

export default function ManagerDashboard() {
  // moved hooks into component (fixes eslint rules-of-hooks)
  const [funnelChartState, setFunnelChartState] = useState(initialFunnelChartState);
  const [stageNameToId, setStageNameToId] = useState({});
  const [sourcesChartData, setSourcesChartData] = useState(initialSourcesChartData);
  const [isSourcesLoaded, setIsSourcesLoaded] = useState(false);

  // move members state above any useEffect that references it
  const [members, setMembers] = useState([]);
  const [dateRange, setDateRange] = useState("");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  // Member-list specific date filter (separate from the global/top filter)
  const [memberDateRange, setMemberDateRange] = useState("");
  const [memberCustomStart, setMemberCustomStart] = useState("");
  const [memberCustomEnd, setMemberCustomEnd] = useState("");
  const [filteredMembers, setFilteredMembers] = useState([]);

  // Individual chart date filters
  const [funnelDateRange, setFunnelDateRange] = useState("");
  const [sourcesDateRange, setSourcesDateRange] = useState("");
  const [tasksDateRange, setTasksDateRange] = useState("");
  const [perfDateRange, setPerfDateRange] = useState("");

  // Calendar dropdown anchors
  const [funnelAnchor, setFunnelAnchor] = useState(null);
  const [sourcesAnchor, setSourcesAnchor] = useState(null);
  const [tasksAnchor, setTasksAnchor] = useState(null);
  const [perfAnchor, setPerfAnchor] = useState(null);
  const [stageDealData, setStageDealData] = useState([]);
  const [openSourcesModal, setOpenSourcesModal] = useState(false);

  // fetch manager pipeline summary and update funnel chart (uses stageAPI)
  useEffect(() => {
    let mounted = true;
    const loadPipeline = async () => {
      try {
        const params = {};
        if (funnelDateRange && funnelDateRange !== "") {
          // funnelDateRange can be a number-of-days string or a custom object
          // like { startDate: 'YYYY-MM-DD', endDate: 'YYYY-MM-DD' } from
          // ChartDateFilter. Handle both shapes.
          // Helper to convert Date to local YYYY-MM-DD (not UTC)
        const formatLocalDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };
        
        if (typeof funnelDateRange === 'object' && funnelDateRange.startDate && funnelDateRange.endDate) {
            // Use local date formatting, not ISO (which converts to UTC)
            params.startDate = funnelDateRange.startDate instanceof Date 
              ? formatLocalDate(funnelDateRange.startDate)
              : String(funnelDateRange.startDate).split('T')[0];
            params.endDate = funnelDateRange.endDate instanceof Date 
              ? formatLocalDate(funnelDateRange.endDate)
              : String(funnelDateRange.endDate).split('T')[0];
          } else {
            const days = Number(funnelDateRange);
            if (!isNaN(days) && days > 0) {
              const endDate = new Date();
              const startDate = new Date();
              startDate.setDate(endDate.getDate() - days);
              params.startDate = startDate.toISOString().split('T')[0];
              params.endDate = endDate.toISOString().split('T')[0];
            }
          }
        }

        const res = await stageAPI.getManagerPipelineSummary(params, selectedUserId);
        const stageDetails = res?.stageDetails || [];
        if (stageDetails.length === 0) return;

        // ✅ Show all stages (including zero-count for complete funnel view)
        const labels = stageDetails.map(s => s.stageName);
        const actualValues = stageDetails.map(s => s.total || 0);
        const stageIds = stageDetails.map(s => s.stageId);
        const colors = stageDetails.map((_, i) =>
          `rgba(${100 + ((i * 40) % 155)}, ${50 + ((i * 60) % 155)}, ${150 + ((i * 30) % 105)}, 0.85)`
        );

        if (mounted) {
          setFunnelChartState({
            labels,
            datasets: [{
              label: "Overall Lead Funnel",
              data: actualValues,
              actualValues: actualValues,
              stageIds: stageIds,
              backgroundColor: colors,
              borderWidth: 0,
              barThickness: 24
            }]
          });
        }
      } catch (err) {
        console.error("Failed to load pipeline summary:", err);
      }
    };
    loadPipeline();
    return () => { mounted = false; };
  }, [funnelDateRange]);

  // build stageName->id mapping when members load (used to pass proper stageId to stage-user API)
  useEffect(() => {
    const map = {};
    members.forEach((m) => {
      (m.stages || []).forEach((s) => {
        if (s.stageName && s.stageId) map[s.stageName] = s.stageId;
      });
    });
    if (Object.keys(map).length) setStageNameToId(map);
  }, [members]);

  const [openStageModal, setOpenStageModal] = useState(false);
  const [selectedStage, setSelectedStage] = useState(null);
  const [selectedStageId, setSelectedStageId] = useState(null);
  const [stageUserChartData, setStageUserChartData] = useState({
    labels: [],
    datasets: [],
  });

  const [openUserLineModal, setOpenUserLineModal] = useState(false);
  const [selectedUserForLine, setSelectedUserForLine] = useState(null);

  const [openTasksModal, setOpenTasksModal] = useState(false);
  // Tab state for Team Tasks fullscreen dialog
  const [tasksTab, setTasksTab] = useState(0);

  // State for Task Detail modal
  const [openTaskDetailModal, setOpenTaskDetailModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoverPos, setHoverPos] = useState({ x: 0, y: 0 });
  const [showStageAction, setShowStageAction] = useState(false);
  const [openTeamPerfModal, setOpenTeamPerfModal] = useState(false);
  const [teamPerfData, setTeamPerfData] = useState({ labels: [], datasets: [] });
  const [userStageItems, setUserStageItems] = useState([]);

  // Top Customer Questions modal + date filter state
  const [openQuestionsModal, setOpenQuestionsModal] = useState(false);
  const [questionsDateRange, setQuestionsDateRange] = useState("");
  const [questionsAnchor, setQuestionsAnchor] = useState(null);
  const questionsChartRef = useRef(null);
  const questionsLabelTooltipRef = useRef(null);

  // Top Customer Questions — fetched from API
  const [customerQuestionsData, setCustomerQuestionsData] = useState({ labels: [], datasets: [{ label: "Asked by (customers)", data: [], backgroundColor: [], borderWidth: 0, maxBarThickness: 22 }] });

  const fetchTopQuestions = async (overrideDateRange) => {
    const activeDateRange = overrideDateRange !== undefined ? overrideDateRange : questionsDateRange;
    try {
      const params = {};
      
      // Helper to convert Date to local YYYY-MM-DD (not UTC)
      const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      if (activeDateRange && activeDateRange !== "") {
        if (typeof activeDateRange === 'object' && activeDateRange.startDate && activeDateRange.endDate) {
          // Use local date formatting, not ISO (which converts to UTC)
          params.startDate = activeDateRange.startDate instanceof Date 
            ? formatLocalDate(activeDateRange.startDate)
            : String(activeDateRange.startDate).split('T')[0];
          params.endDate = activeDateRange.endDate instanceof Date 
            ? formatLocalDate(activeDateRange.endDate)
            : String(activeDateRange.endDate).split('T')[0];
        } else {
          let days = Number(activeDateRange);
          // Handle descriptive strings if they leak in
          if (isNaN(days)) {
            const m = String(activeDateRange).match(/(\d+)/);
            days = m ? Number(m[1]) : NaN;
          }
          if (!isNaN(days) && days > 0) {
            const end = new Date();
            const start = new Date();
            start.setDate(end.getDate() - days);
            params.startDate = formatLocalDate(start);
            params.endDate = formatLocalDate(end);
          }
        }
      }

      // Add userId to params if a specific user is selected (consistent with other charts)
      if (selectedUserId) {
        params.userId = selectedUserId;
      }

      const res = await stageAPI.getTopQuestions(params);
      // New API shape: { data: [{ category, questions: [{ question, frequency, importance_score, ... }] }] }
      const categories = res?.data;
      
      if (!Array.isArray(categories) || categories.length === 0) {
        setCustomerQuestionsData({ labels: [], datasets: [{ label: "Asked by (customers)", data: [], backgroundColor: [], borderWidth: 0, maxBarThickness: 22 }] });
        return;
      }

      // Flatten all questions, filter importance_score > 5, sort by frequency desc
      const allQuestions = categories.flatMap(cat =>
        (Array.isArray(cat.questions) ? cat.questions : []).map(q => ({
          ...q,
          category: q.category || cat.category,
        }))
      ).filter(q => (q.importance_score || 0) > 5)
        .sort((a, b) => (b.frequency || 0) - (a.frequency || 0));

      if (!allQuestions.length) {
        setCustomerQuestionsData({ labels: [], datasets: [{ label: "Asked by (customers)", data: [], backgroundColor: [], borderWidth: 0, maxBarThickness: 22 }] });
        return;
      }

      const labels = allQuestions.map(q => q.question);
      const counts = allQuestions.map(q => q.frequency || 1);
      const colors = allQuestions.map((q, i) =>
        `rgba(${100 + ((i * 40) % 155)}, ${50 + ((i * 60) % 155)}, ${150 + ((i * 30) % 105)}, 0.85)`
      );

      setCustomerQuestionsData({
        labels,
        datasets: [{
          label: "Asked by (customers)",
          data: counts,
          backgroundColor: colors,
          borderWidth: 0,
          maxBarThickness: 22,
          // store extra info for tooltip
          importanceScores: allQuestions.map(q => q.importance_score),
          categories: allQuestions.map(q => q.category),
        }],
      });
    } catch (err) {
      console.error("Failed to fetch top questions:", err);
      setCustomerQuestionsData({ labels: [], datasets: [{ label: "Asked by (customers)", data: [], backgroundColor: [], borderWidth: 0, maxBarThickness: 22 }] });
    }
  };

  // Team tasks summary (drives Team Tasks — Summary chart)
  const [teamTaskSummary, setTeamTaskSummary] = useState([]);

  const buildTeamTaskSummaryFromTasks = (tasks = [], membersList = []) => {
    const byMember = {};
    const now = new Date();

    tasks.forEach((t) => {
      const assigneeId = t.assignedTo ? String(t.assignedTo) : null;
      const assigneeName = t.assignedToName || "Unknown";
      if (!assigneeId) return;
      if (!byMember[assigneeId]) byMember[assigneeId] = { user_name: assigneeName, id: assigneeId, tasks: [] };
      byMember[assigneeId].tasks.push(t);
    });

    // Build summary aligned with provided members list (falls back to members present in tasks)
    const memberSources = membersList && membersList.length ? membersList.map(m => ({ id: m.id, name: m.name })) : Object.values(byMember).map(b => ({ id: b.id, name: b.user_name }));

    const summary = memberSources.map((m) => {
      const bucket = byMember[String(m.id)] || { tasks: [] };
      const tasksArr = bucket.tasks || [];
      let pending_total = 0;
      const in_progress_tasks = [];
      let recently_completed = 0;
      let overdue = 0;

      tasksArr.forEach((t) => {
        const s = (t.status || "").toString().toLowerCase();
        if (s.includes("pend") || s === "") pending_total += 1;
        if (s.includes("progress")) in_progress_tasks.push(t);
        if (s.includes("complete")) recently_completed += 1;
        if (t.dueDate) {
          const d = new Date(t.dueDate);
          if (!isNaN(d.getTime()) && d < now && !s.includes("complete")) overdue += 1;
        }
      });

      return {
        id: m.id,
        user_name: m.name,
        pending_total,
        in_progress_tasks,
        recently_completed,
        overdue,
      };
    });

    return summary;
  };

  const navigate = useNavigate();
  const location = useLocation();
  // If this page was opened with a selected member (via navigation state or ?userId=...),
  // prefer showing that user's pipeline/metrics instead of team-level data.
  const urlParams = new URLSearchParams(location.search || "");
  const selectedUserIdFromQuery = urlParams.get("userId") || null;
  const selectedUserIdFromState = location?.state?.member?.id || location?.state?.memberId || null;
  const selectedUserId = selectedUserIdFromState || selectedUserIdFromQuery || null;
  const funnelRef = useRef(null);
  const stageUserChartRef = useRef(null);
  const stageOpeningRef = useRef(false); // guard against double-open
  const stageModalOpenRef = useRef(false); // sync ref mirrors openStageModal for use inside async handlers

  useEffect(() => {
    fetchMembers();
    fetchTeamPerformance();
    fetchLeadSourceMetrics();
    fetchTasks();
    fetchTopQuestions(questionsDateRange);
    // eslint-disable-next-line
  }, []);

  // Refetch data when individual chart filters change
  useEffect(() => {
    fetchLeadSourceMetrics();
  }, [sourcesDateRange]);

  useEffect(() => {
    fetchTeamPerformance();
  }, [perfDateRange]);

  useEffect(() => {
    fetchTasks();
  }, [tasksDateRange]);

  useEffect(() => {
    fetchTopQuestions(questionsDateRange);
    // eslint-disable-next-line
  }, [questionsDateRange]);

  // Propagate the top-level `dateRange` (and custom dates) to individual
  // chart filters so the top control applies to the whole page (charts,
  // member ring, and any API calls that depend on those chart date ranges).
  useEffect(() => {
    // Clear individual filters when top filter is empty
    if (!dateRange || dateRange === "") {
      setFunnelDateRange("");
      setSourcesDateRange("");
      setTasksDateRange("");
      setPerfDateRange("");
      setQuestionsDateRange("");
      // also clear member-specific filter so MemberRing resets
      setMemberDateRange("");
      setMemberCustomStart("");
      setMemberCustomEnd("");
      return;
    }

    // If custom range selected, build an object matching other handlers
    if ((dateRange === "custom" || (typeof dateRange === 'object' && dateRange?.startDate)) && customStart && customEnd) {
      const rangeObj = { startDate: customStart, endDate: customEnd };
      setFunnelDateRange(rangeObj);
      setSourcesDateRange(rangeObj);
      setTasksDateRange(rangeObj);
      setPerfDateRange(rangeObj);
      setQuestionsDateRange(rangeObj);
      // propagate resolved date object to member filter — NOT the "custom" string
      // so the member CustomFilterBar doesn't auto-open its date pickers
      setMemberDateRange(rangeObj);
      setMemberCustomStart(customStart);
      setMemberCustomEnd(customEnd);
      return;
    }

    // If user just selected "custom" but hasn't applied dates yet — don't propagate anything
    if (dateRange === "custom" && (!customStart || !customEnd)) {
      return;
    }

    // For numeric/quick filters, propagate the same value (e.g., "30" or "Last 30 Days")
    setFunnelDateRange(dateRange);
    setSourcesDateRange(dateRange);
    setTasksDateRange(dateRange);
    setPerfDateRange(dateRange);
    setQuestionsDateRange(dateRange);
    // also set the member-level quick filter so MemberRing updates
    setMemberDateRange(dateRange);
  }, [dateRange, customStart, customEnd]);

  const fetchTasks = async () => {
    try {
      const params = {};
      // Helper to convert Date to local YYYY-MM-DD (not UTC)
      const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      
      if (tasksDateRange && tasksDateRange !== "") {
        // support either numeric quick-filters (days), descriptive labels like
        // "Last 30 Days", or a custom object { startDate, endDate }
        if (typeof tasksDateRange === 'object' && tasksDateRange.startDate && tasksDateRange.endDate) {
          // Use local date formatting, not ISO (which converts to UTC)
          params.startDate = tasksDateRange.startDate instanceof Date 
            ? formatLocalDate(tasksDateRange.startDate)
            : String(tasksDateRange.startDate).split('T')[0];
          params.endDate = tasksDateRange.endDate instanceof Date 
            ? formatLocalDate(tasksDateRange.endDate)
            : String(tasksDateRange.endDate).split('T')[0];
        } else {
          // try numeric conversion first, then fall back to extracting digits
          let days = Number(tasksDateRange);
          if (isNaN(days)) {
            const m = String(tasksDateRange).match(/(\d+)/);
            days = m ? Number(m[1]) : NaN;
          }
          if (!isNaN(days) && days > 0) {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(endDate.getDate() - days);
            params.startDate = formatLocalDate(startDate);
            params.endDate = formatLocalDate(endDate);
          }
        }
      }

      // Add userId to params if a specific user is selected
      if (selectedUserId) {
        params.userId = selectedUserId;
      }
      
      const res = await stageAPI.getTeamTaskStats(params);
      console.log("fetchTasks response:", res);
      console.debug('[fetchTasks] params:', params, 'tasksDateRange:', tasksDateRange);

      // Support different backend shapes: { byMember: [...] } or { data: [...] }
      const memberArray = res?.byMember || res?.data?.byMember || res?.data || res?.byMember || [];
      const entries = Array.isArray(memberArray) ? memberArray : [];

      // If caller provided a date range, the backend may not always honor it.
      // When a date range is present, prefer to compute counts client-side
      // from per-member `tasks` arrays so the UI respects the selected range.
      const willFilterClientSide = params.startDate && params.endDate;

      if (willFilterClientSide) {
        // Parse start/end as UTC to avoid timezone skew when comparing against
        // API timestamps which are in ISO Zulu (UTC) format.
        const sT = Date.parse(`${params.startDate}T00:00:00.000Z`);
        const eT = Date.parse(`${params.endDate}T23:59:59.999Z`);
        console.debug('[fetchTasks] client-side filter active (UTC):', { sT: new Date(sT).toISOString(), eT: new Date(eT).toISOString(), params });

        const summaryFromFiltered = entries.map((m) => {
          const rawTasks = Array.isArray(m.tasks) ? m.tasks : [];
          const filteredTasks = rawTasks.filter((t) => {
            const dt = t.createdAt || t.created_at || t.created || null;
            if (!dt) return false;
            const tms = Date.parse(dt);
            if (isNaN(tms)) return false;
            return tms >= sT && tms <= eT;
          });

          console.debug('[fetchTasks] member', m.memberId || m.id || m.memberName, 'rawTasks=', rawTasks.length, 'filteredTasks=', filteredTasks.length, filteredTasks.slice(0, 2).map(t => t.createdAt || t.created_at));

          // build counts from filteredTasks
          const counts = filteredTasks.reduce((acc, t) => {
            const s = (t.status || '').toString();
            if (s.toLowerCase().includes('pend') || s === '') acc.Pending = (acc.Pending || 0) + 1;
            if (s.toLowerCase().includes('progress')) acc['In Progress'] = (acc['In Progress'] || 0) + 1;
            if (s.toLowerCase().includes('complete')) acc.Completed = (acc.Completed || 0) + 1;
            // overdue may sometimes be determined server-side; fallback to status text
            if (s.toLowerCase().includes('overdue')) acc.Overdue = (acc.Overdue || 0) + 1;
            return acc;
          }, {});

          return {
            id: m.memberId || m.id,
            user_name: m.memberName || m.userName || m.member_name || m.name || 'Unknown',
            pending_total: counts.Pending || 0,
            in_progress_tasks: new Array(counts['In Progress'] || 0),
            recently_completed: counts.Completed || 0,
            overdue: counts.Overdue || 0,
            tasks: filteredTasks,
          };
        });

        console.log('Built team summary from filtered tasks:', summaryFromFiltered);
        setTeamTaskSummary(summaryFromFiltered);
      } else {
        // No client-side date filter requested — prefer server-provided statusCounts when available
        const allTasks = entries.flatMap((m) => m.tasks || []);
        console.log('Fetched tasks (flattened):', allTasks);

        const hasStatusCounts = entries.length > 0 && entries.every((m) => m && typeof m.statusCounts === 'object');

        if (hasStatusCounts) {
          const summaryFromStatus = entries.map((m) => ({
            id: m.memberId || m.id,
            user_name: m.memberName || m.userName || m.member_name || m.name || 'Unknown',
            pending_total: (m.statusCounts && (m.statusCounts.Pending || m.statusCounts.Pending === 0)) ? (m.statusCounts.Pending || 0) : 0,
            in_progress_tasks: new Array(m.statusCounts['In Progress'] || 0),
            recently_completed: m.statusCounts.Completed || 0,
            overdue: m.statusCounts.Overdue || 0,
            tasks: m.tasks || []
          }));

          console.log('Built team summary from statusCounts:', summaryFromStatus);
          setTeamTaskSummary(summaryFromStatus);
        } else {
          // Fallback: build from raw tasks and members mapping
          const membersForSummary = entries.map((m) => ({ id: m.memberId || m.id, name: m.memberName || m.userName }));
          const summary = buildTeamTaskSummaryFromTasks(allTasks, membersForSummary.length ? membersForSummary : members);
          console.log("Built team summary:", summary);
          setTeamTaskSummary(summary);
        }
      }
    } catch (err) {
      console.error("Failed to fetch tasks:", err);
    }
  };

  // Debug: log teamTaskSummary whenever it changes
  useEffect(() => {
    console.log('teamTaskSummary state updated:', teamTaskSummary);
  }, [teamTaskSummary]);

  // Derived chart data for Team Tasks — Summary
  const currentTeamTasks = teamTaskSummary && teamTaskSummary.length ? teamTaskSummary : [];
  const inProgressCounts = currentTeamTasks.map((u) => (Array.isArray(u.in_progress_tasks) ? u.in_progress_tasks.length : 0));
  const taskLabels = currentTeamTasks.map((u) => u.user_name);
  const taskDatasets = [
    {
      label: "Overdue",
      data: currentTeamTasks.map((u) => u.overdue || 0),
      backgroundColor: "rgba(244,67,54,0.85)",
      barThickness: 18,
      maxBarThickness: 25,
    },
    {
      label: "Pending (total)",
      data: currentTeamTasks.map((u) => u.pending_total || 0),
      backgroundColor: "rgba(255,193,7,0.85)",
      barThickness: 18,
      maxBarThickness: 25,
    },
    {
      label: "Completed",
      data: currentTeamTasks.map((u) => u.recently_completed || 0),
      backgroundColor: "rgba(76,175,80,0.85)",
      barThickness: 18,
      maxBarThickness: 25,
    },
  ];

  const tasksChartData = { labels: taskLabels, datasets: taskDatasets };
  const tasksChartOptions = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top", labels: { boxWidth: 12, font: { size: 12, weight: 'normal' } } },
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: function (context) {
            return context.dataset.label + ': ' + (context.raw || 0);
          }
        }
      },
    },
    scales: {
      x: {
        stacked: true,
        beginAtZero: true,
        title: {
          display: true,
          text: 'Number of Tasks →',
          font: { size: 13, weight: 'normal' },
          color: '#666',
          padding: { top: 10, bottom: 5 }
        },
        grid: { display: true, color: "rgba(0,0,0,0.06)" },
        ticks: { font: { size: 12, weight: 'normal' } },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: 'Team Members →',
          font: { size: 13, weight: 'normal' },
          color: '#666',
          padding: { left: 25, right: 15 }
        },
        grid: { display: false },
        ticks: {
          font: { size: 12, weight: 'normal' },
          autoSkip: false,
          padding: 8,
          maxRotation: 0,
          minRotation: 0
        },
      },
    },
    elements: {
      bar: { borderRadius: 0, borderSkipped: false, barThickness: 18 },
    },
  };

  const fetchLeadSourceMetrics = async () => {
    setIsSourcesLoaded(false);
    try {
      const params = {};
      // Helper to convert Date to local YYYY-MM-DD (not UTC)
      const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      
      if (sourcesDateRange && sourcesDateRange !== "") {
        // support either numeric quick-filters (days) or a custom object { startDate, endDate }
        if (typeof sourcesDateRange === 'object' && sourcesDateRange.startDate && sourcesDateRange.endDate) {
          // Use local date formatting, not ISO (which converts to UTC)
          params.startDate = sourcesDateRange.startDate instanceof Date 
            ? formatLocalDate(sourcesDateRange.startDate)
            : String(sourcesDateRange.startDate).split('T')[0];
          params.endDate = sourcesDateRange.endDate instanceof Date 
            ? formatLocalDate(sourcesDateRange.endDate)
            : String(sourcesDateRange.endDate).split('T')[0];
        } else {
          const days = Number(sourcesDateRange);
          if (!isNaN(days) && days > 0) {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(endDate.getDate() - days);
            params.startDate = formatLocalDate(startDate);
            params.endDate = formatLocalDate(endDate);
          }
        }
      }

      // Add userId to params if a specific user is selected
      if (selectedUserId) {
        params.userId = selectedUserId;
      }
      
      const res = await stageAPI.getLeadSourceMetrics(params);
      const metrics = res?.leadSourceMetrics || [];

      // If caller provided a date range (params.startDate & params.endDate),
      // the backend currently does not filter by dates in all cases. To ensure
      // the chart respects the selected range, perform client-side filtering
      // and recompute metrics from `res.leads` and `res.deals` when dates present.
      const willFilterClientSide = params.startDate && params.endDate;

      let finalMetrics = metrics;
      if (willFilterClientSide) {
        const sT = new Date(params.startDate).setHours(0, 0, 0, 0);
        const eT = new Date(params.endDate).setHours(23, 59, 59, 999);

        const leads = Array.isArray(res?.leads) ? res.leads : [];
        const deals = Array.isArray(res?.deals) ? res.deals : [];

        const itemsForMetrics = [];

        // include leads whose created_time falls in range
        leads.forEach((l) => {
          const dt = l.created_time || l.createdAt || l.created_at || null;
          if (!dt) return;
          const t = new Date(dt).getTime();
          if (isNaN(t)) return;
          if (t >= sT && t <= eT) itemsForMetrics.push({ source: l.source || null });
        });

        // include deals whose createdAt falls in range
        deals.forEach((d) => {
          const dt = d.createdAt || d.created_at || null;
          if (!dt) return;
          const t = new Date(dt).getTime();
          if (isNaN(t)) return;
          if (t >= sT && t <= eT) itemsForMetrics.push({ source: d.source || null });
        });

        // Reuse server-side mapping for display names
        const SOURCE_DISPLAY = {
          facebook: "FB Lead Ads",
          contact_form: "Website",
          website: "Website",
          whatsapp: "WhatsApp",
          google_ads: "Google",
          google: "Google",
          youtube: "Youtube",
          manual: "Physical / Manual Entry",
          unknown: "[Other Values]",
          lead: "[Other Values]",
        };
        const EXTRA_MAP = {
          justdial: "JustDial",
          inbound_phone: "Inbound Phone call",
          phone: "Inbound Phone call",
          marketing: "Marketing Campaign",
          campaign: "Marketing Campaign",
        };

        const counts = new Map();
        itemsForMetrics.forEach((it) => {
          let key = (it.source || "unknown").toString().toLowerCase();
          let name = SOURCE_DISPLAY[key] || EXTRA_MAP[key] || null;
          if (!name) {
            if (key.includes("youtube")) name = "Youtube";
            else if (key.includes("utm") || key.includes("campaign") || key.includes("marketing")) name = "Marketing Campaign";
            else if (key.includes("justdial")) name = "JustDial";
            else name = "[Other Values]";
          }
          counts.set(name, (counts.get(name) || 0) + 1);
        });

        const displayOrder = [
          "FB Lead Ads",
          "JustDial",
          "Inbound Phone call",
          "Website",
          "WhatsApp",
          "Marketing Campaign",
          "Google",
          "Youtube",
          "[Other Values]",
          "Physical / Manual Entry",
        ];

        finalMetrics = displayOrder.filter((n) => counts.has(n)).map((n) => ({ source_name: n, lead_count: counts.get(n) }));
      }

      if (!finalMetrics || finalMetrics.length === 0) {
        setSourcesChartData(initialSourcesChartData);
        setIsSourcesLoaded(true);
        return;
      }

      const labels = finalMetrics.map((m) => m.source_name);
      const counts = finalMetrics.map((m) => m.lead_count);
      const colors = labels.map((_, i) => `rgba(${100 + ((i * 40) % 155)}, ${50 + ((i * 60) % 155)}, ${150 + ((i * 30) % 105)}, 0.85)`);

      setSourcesChartData({
        labels,
        datasets: [{ label: "Leads by Source", data: counts, backgroundColor: colors, borderWidth: 0, maxBarThickness: 25 }],
      });
      setIsSourcesLoaded(true);
    } catch (err) {
      console.error("Failed to fetch lead source metrics:", err);
      setSourcesChartData(initialSourcesChartData);
      setIsSourcesLoaded(true);
    }
  };
  const handleUserNameClick = (userId) => {
    navigate(`/home/member/${userId}`, {
      state: { fromTaskGraph: true, from: 'manager-dashboard' }, // Pass state
    });
  };

  const fetchTeamPerformance = async () => {
    try {
      const params = {};
      console.log("🔍 fetchTeamPerformance called - perfDateRange:", perfDateRange, "dateRange:", dateRange);
      
      // Helper to convert Date to local YYYY-MM-DD (not UTC)
      const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      
      if (perfDateRange && perfDateRange !== "") {
        // Support both numeric day ranges and custom date objects
        if (typeof perfDateRange === 'object' && perfDateRange.startDate && perfDateRange.endDate) {
          // Use local date formatting, not ISO (which converts to UTC)
          params.startDate = perfDateRange.startDate instanceof Date 
            ? formatLocalDate(perfDateRange.startDate)
            : String(perfDateRange.startDate).split('T')[0];
          params.endDate = perfDateRange.endDate instanceof Date 
            ? formatLocalDate(perfDateRange.endDate)
            : String(perfDateRange.endDate).split('T')[0];
          console.log("✅ Using perfDateRange object - dates:", { startDate: params.startDate, endDate: params.endDate });
        } else {
          const days = Number(perfDateRange);
          if (!isNaN(days) && days > 0) {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(endDate.getDate() - days);
            params.startDate = formatLocalDate(startDate);
            params.endDate = formatLocalDate(endDate);
            console.log("✅ Using perfDateRange numeric days -", days);
          }
        }
      } else if (dateRange && dateRange !== "") {
        // Fallback: If perfDateRange is empty but dateRange is set, use dateRange
        console.log("⚠️ perfDateRange empty, using fallback dateRange");
        if (typeof dateRange === 'object' && dateRange.startDate && dateRange.endDate) {
          params.startDate = dateRange.startDate instanceof Date 
            ? formatLocalDate(dateRange.startDate)
            : String(dateRange.startDate).split('T')[0];
          params.endDate = dateRange.endDate instanceof Date 
            ? formatLocalDate(dateRange.endDate)
            : String(dateRange.endDate).split('T')[0];
        } else {
          const days = Number(dateRange);
          if (!isNaN(days) && days > 0) {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(endDate.getDate() - days);
            params.startDate = formatLocalDate(startDate);
            params.endDate = formatLocalDate(endDate);
          }
        }
      }

      // Add userId to params if a specific user is selected
      if (selectedUserId) {
        params.userId = selectedUserId;
      }
      
      console.log("📤 Sending to API - params:", params);
      const res = await stageAPI.getTeamPerformanceMetrics(params);
      console.log('fetchTeamPerformance response:', res);

      // Support response shapes: { byMember: [...] } or { data: [...] } or { data: { byMember: [...] } }
      // If a date range was requested but backend may not filter, compute counts client-side
      const willFilterClientSide = params.startDate && params.endDate;

      let members = res?.byMember || res?.data || res?.data?.byMember || [];

      if (willFilterClientSide) {
        const sT = Date.parse(`${params.startDate}T00:00:00.000Z`);
        const eT = Date.parse(`${params.endDate}T23:59:59.999Z`);

        // Normalize members into minimal shape computed from closed_items/open_items if available
        const src = Array.isArray(res?.byMember) ? res.byMember : Array.isArray(res?.data) ? res.data : Array.isArray(res?.data?.byMember) ? res.data.byMember : [];
        members = src.map((m) => {
          // pick common name fields
          const name = m.memberName || m.userName || m.user_name || m.name || 'Unknown';
          const teamType = m.teamType || '';

          const closedItems = Array.isArray(m.closed_items) ? m.closed_items : Array.isArray(m.closedItems) ? m.closedItems : [];
          const openItems = Array.isArray(m.open_items) ? m.open_items : Array.isArray(m.openItems) ? m.openItems : [];

          // Filter items by date range
          const filteredClosed = closedItems.filter((it) => {
            const dt = it && (it.createdAt || it.created_at || it.created);
            if (!dt) return false;
            const t = Date.parse(dt);
            if (isNaN(t)) return false;
            return t >= sT && t <= eT;
          });

          const filteredOpen = openItems.filter((it) => {
            const dt = it && (it.createdAt || it.created_at || it.created);
            if (!dt) return false;
            const t = Date.parse(dt);
            if (isNaN(t)) return false;
            return t >= sT && t <= eT
          });

          // Recalculate team-specific wins from filtered closed items
          let telesalesWins = 0;
          let salesWins = 0;

          if (teamType === 'telesales') {
            telesalesWins = filteredClosed.length; // All closed items are wins for telesales
          } else if (teamType === 'sales') {
            salesWins = filteredClosed.filter((it) => (it.status || '').toString().toLowerCase() === 'closed_won').length;
          }

          const closedLostCount = filteredClosed.filter((it) => (it.status || '').toString().toLowerCase().includes('closed_lost')).length;

          return {
            memberName: name,
            teamType: teamType,
            breakdown: { closed_lost: closedLostCount, open: filteredOpen.length },
            open_items: filteredOpen,
            closed_items: filteredClosed,
            telesales_wins: telesalesWins,
            sales_wins: salesWins,
          };
        });
      }

      if (!Array.isArray(members) || members.length === 0) {
        setTeamPerfData({ labels: [], datasets: [] });
        return;
      }

      // Pick common name keys used by different API shapes
      const labels = members.map((m) => m.memberName || m.userName || m.user_name || m.name || 'Unknown');

      // Team-specific wins: telesales_wins for telesales, sales_wins for sales
      const winsData = members.map((m) => {
        const teamType = m.teamType || '';
        if (teamType === 'telesales') {
          return m.telesales_wins || m.breakdown?.wins || 0;
        } else if (teamType === 'sales') {
          return m.sales_wins || m.breakdown?.closed_won || 0;
        }
        // Fallback to breakdown.wins or closed_won for unknown team types
        return m.breakdown?.wins || m.breakdown?.closed_won || m.closed_won || 0;
      });

      const closedLostData = members.map((m) => m.breakdown?.closed_lost || m.closed_lost || 0);
      const openData = members.map((m) => m.breakdown?.open || m.open || 0);

      setTeamPerfData({
        labels,
        datasets: [
          {
            label: "Wins",
            data: winsData,
            actualValues: winsData,
            backgroundColor: "rgba(76,175,80,0.85)",
            borderWidth: 0,
            barThickness: 18,
            datalabels: { display: false }
          },
          {
            label: "Closed Lost",
            data: closedLostData,
            actualValues: closedLostData,
            backgroundColor: "rgba(244,67,54,0.85)",
            borderWidth: 0,
            barThickness: 18,
            datalabels: { display: false }
          },
          {
            label: "Open",
            data: openData,
            actualValues: openData,
            backgroundColor: "rgba(255,193,7,0.85)",
            borderWidth: 0,
            barThickness: 18,
            datalabels: { display: false }
          }
        ]
      });
    } catch (err) {
      console.error("Failed to fetch team performance:", err);
      setTeamPerfData({ labels: [], datasets: [] });
    }
  };

  const fetchMembers = async () => {
    try {
      const response = await apiRequest(
        "get",
        "/invite/get-manager-invites-all-info"
      );
      console.log("fetchMembers response:", response);
      const invites =
        response?.data?.invites ||
        response?.invites ||
        response?.data?.data?.invites ||
        [];
      const apiMembers = invites
        .map((invite) => {
          const user = invite.userDetails;
          if (!user || !user.pipelines) return null;
          // collect per-deal createdAt timestamps if available
          let dealDates = [];
          const stagesArr = (user.pipelines && user.pipelines.length > 0 && user.pipelines[0].stages) || [];
          const stagesMapped = stagesArr.map((stage) => {
            const deals = Array.isArray(stage.deals) ? stage.deals : [];
            deals.forEach((d) => {
              const dt = d && (d.createdAt || d.created_at);
              if (dt) dealDates.push(dt);
            });
            return {
              stageId: stage._id,
              stageName: stage.name,
              dealsCount: deals.length,
              revenue: deals.reduce((sum, d) => sum + (Number(d.value) || 0), 0),
              // keep raw deals if needed elsewhere
              dealsRaw: deals,
            };
          });

          return {
            id: user._id,
            name: user.name,
            _source: 'invites',
            riskScore: user.riskScore || 0,
            currency: "INR",
            contact: { email: user.email, phone: user.phoneNumber },
            stages: stagesMapped,
            createdAt: user.createdAt,
            // normalized array of deal createdAt strings (if any)
            dealDates: dealDates,
            // team type from invite API
            teamType: user.teamType || null,
          };
        })
        .filter(Boolean)
        .sort((a, b) => a.name.localeCompare(b.name));
      setMembers(apiMembers);
      // Initialize filtered members when members are first loaded
      if (apiMembers.length > 0 && (!dateRange || dateRange === "")) {
        setFilteredMembers(apiMembers);
      }
    } catch (err) {
      setMembers([]);
    }
  };

  // If invite-based members are not available, but we have stage-based counts
  // from `/tasks/team-stage-deal-count`, synthesize a simple `members` array so
  // the MemberStageRing can still render a visualization for invited members.
  useEffect(() => {
    if ((!members || members.length === 0) && stageDealData && stageDealData.length) {
      const synthetic = stageDealData.map((m) => {
        // preserve stageDetails if present (object mapping stageName -> array of items)
        const stageDetails = m.stageDetails || m.stage_details || {};
        // collect dealDates from stageDetails
        const dealDates = Object.values(stageDetails || {}).flatMap((arr) =>
          (Array.isArray(arr) ? arr : []).map((it) => it && (it.createdAt || it.created_at)).filter(Boolean)
        );

        return {
          id: m.memberId,
          name: m.memberName || "Unknown",
          email: m.email || m.memberEmail || null,
          _source: 'stageDealCount',
          riskScore: 0,
          currency: "INR",
          contact: { email: m.email || m.memberEmail || null },
          stages: Object.keys(m.stages || {}).map((stageName) => ({
            stageId: null,
            stageName,
            dealsCount: m.stages[stageName] || 0,
            revenue: 0,
          })),
          createdAt: m.createdAt || null,
          stageDetails: stageDetails,
          dealDates: dealDates,
        };
      });

      setMembers(synthetic);
    }
    // only run when stageDealData changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stageDealData]);

  useEffect(() => {
    // Determine effective date filter for members: prefer member-specific (bottom control),
    // otherwise fall back to the global/top `dateRange`.
    const now = new Date();
    let startDate = null;
    let endDate = now;

    // Build two ranges: global (top) and member-specific (bottom). Then compute
    // the intersection so the member ring is filtered by both (global applies
    // site-wide; member filter further narrows the member ring).
    const parseRange = (rangeVal, sVal, eVal) => {
      let s = null;
      let e = null;
      // Handle object shape { startDate, endDate } (from ChartDateFilter or propagated global)
      if (rangeVal && typeof rangeVal === 'object' && rangeVal.startDate && rangeVal.endDate) {
        s = new Date(rangeVal.startDate);
        e = new Date(rangeVal.endDate);
        e.setHours(23, 59, 59, 999);
      } else if (rangeVal && rangeVal !== "" && rangeVal !== "custom") {
        const days = Number(rangeVal);
        if (!isNaN(days) && days > 0) {
          e = new Date(now);
          s = new Date(now);
          s.setDate(e.getDate() - days);
        }
      } else if (rangeVal === 'custom' && sVal && eVal) {
        s = new Date(sVal);
        e = new Date(eVal);
        e.setHours(23, 59, 59, 999);
      }
      return { start: s, end: e };
    };

    const globalRange = parseRange(dateRange, customStart, customEnd);
    const memberRange = parseRange(memberDateRange, memberCustomStart, memberCustomEnd);

    // Compute intersection: effectiveStart = max(global.start, member.start),
    // effectiveEnd = min(global.end, member.end). If one side missing, use the other.
    const pickStart = (a, b) => {
      if (!a && !b) return null;
      if (!a) return b;
      if (!b) return a;
      return a.getTime() > b.getTime() ? a : b;
    };
    const pickEnd = (a, b) => {
      if (!a && !b) return null;
      if (!a) return b;
      if (!b) return a;
      return a.getTime() < b.getTime() ? a : b;
    };

    const effectiveStart = pickStart(globalRange.start, memberRange.start);
    const effectiveEnd = pickEnd(globalRange.end, memberRange.end) || now;

    if (effectiveStart) startDate = effectiveStart;
    if (effectiveEnd) endDate = effectiveEnd;

    const filtered = members.filter((m) => {
      // Collect candidate dates from multiple possible places
      let candidateDates = [];

      // direct dealDates (normalized earlier)
      if (Array.isArray(m.dealDates) && m.dealDates.length) candidateDates = candidateDates.concat(m.dealDates);

      // stageDetails object: { stageName: [items] }
      if (m.stageDetails && typeof m.stageDetails === 'object') {
        const vals = Object.values(m.stageDetails || {});
        vals.forEach((arr) => {
          if (Array.isArray(arr)) {
            arr.forEach((it) => {
              if (it) {
                const dt = it.createdAt || it.created_at;
                if (dt) candidateDates.push(dt);
              }
            });
          }
        });
      }

      // stages may contain dealsRaw (when we preserved them for invites)
      if (Array.isArray(m.stages)) {
        m.stages.forEach((s) => {
          if (Array.isArray(s.dealsRaw)) {
            s.dealsRaw.forEach((d) => {
              const dt = d && (d.createdAt || d.created_at);
              if (dt) candidateDates.push(dt);
            });
          }
        });
      }

      // fallback: use member.createdAt if no deal dates available
      if (!candidateDates.length && m.createdAt) candidateDates.push(m.createdAt);

      // If no effective date filter is applied, include all members
      if (!effectiveStart && !globalRange.start && !memberRange.start && !globalRange.end && !memberRange.end) return true;

      // If we still have no candidate dates, exclude when date filter is active
      if (!candidateDates.length) return false;

      // Check if any candidate date falls within range
      const rangeStart = startDate || null;
      const rangeEnd = endDate || now;

      const anyInRange = candidateDates.some((dt) => {
        try {
          const t = new Date(dt).getTime();
          if (isNaN(t)) return false;
          if (rangeStart && t < rangeStart.getTime()) return false;
          if (rangeEnd && t > rangeEnd.getTime()) return false;
          return true;
        } catch (e) {
          return false;
        }
      });

      return anyInRange;
    });

    setFilteredMembers(filtered);
    // debug log to help trace filtering issues
    console.debug('[ManagerDashboard] memberDateFilter:', { globalRange, memberRange, startDate: startDate ? startDate.toISOString() : null, endDate: endDate ? endDate.toISOString() : null, membersCount: members.length, filteredCount: filtered.length });
    members.forEach((m) => console.debug('[ManagerDashboard] member', m.id || m.memberId || m.name, 'createdAt=', m.createdAt, 'dealDates=', m.dealDates || (m.stageDetails ? Object.values(m.stageDetails || {}).flat().map(x => x.createdAt || x.created_at).filter(Boolean) : [])));
  }, [members, memberDateRange, memberCustomStart, memberCustomEnd, dateRange, customStart, customEnd]);

  useEffect(() => {
    const fetchStageDealCount = async () => {
      try {
        // Build params for date filtering
        const params = {};
        const now = new Date();
        let startDate = null;
        let endDate = now;

        // Build two ranges: global (top) and member-specific (bottom). Then compute
        // the intersection so the member ring is filtered by both (global applies
        // site-wide; member filter further narrows the member ring).
        const parseRange = (rangeVal, sVal, eVal) => {
          let s = null;
          let e = null;
          if (rangeVal && typeof rangeVal === 'object' && rangeVal.startDate && rangeVal.endDate) {
            s = new Date(rangeVal.startDate);
            e = new Date(rangeVal.endDate);
            e.setHours(23, 59, 59, 999);
          } else if (rangeVal && rangeVal !== "" && rangeVal !== "custom") {
            const days = Number(rangeVal);
            if (!isNaN(days) && days > 0) {
              e = new Date(now);
              s = new Date(now);
              s.setDate(e.getDate() - days);
            }
          } else if (rangeVal === 'custom' && sVal && eVal) {
            s = new Date(sVal);
            e = new Date(eVal);
            e.setHours(23, 59, 59, 999);
          }
          return { start: s, end: e };
        };

        const globalRange = parseRange(dateRange, customStart, customEnd);
        const memberRange = parseRange(memberDateRange, memberCustomStart, memberCustomEnd);

        const pickStart = (a, b) => {
          if (!a && !b) return null;
          if (!a) return b;
          if (!b) return a;
          return a.getTime() > b.getTime() ? a : b;
        };
        const pickEnd = (a, b) => {
          if (!a && !b) return null;
          if (!a) return b;
          if (!b) return a;
          return a.getTime() < b.getTime() ? a : b;
        };

        const effectiveStart = pickStart(globalRange.start, memberRange.start);
        const effectiveEnd = pickEnd(globalRange.end, memberRange.end);


        if (effectiveStart && effectiveEnd) {
          params.startDate = effectiveStart.toISOString().slice(0, 10);
          params.endDate = effectiveEnd.toISOString().slice(0, 10);
        }

        // debug: log ranges and params so it's easier to trace why API gets these dates
        console.debug('Date Range Params:', {
          globalRange: { start: globalRange.start ? globalRange.start.toISOString().slice(0, 10) : null, end: globalRange.end ? globalRange.end.toISOString().slice(0, 10) : null },
          memberRange: { start: memberRange.start ? memberRange.start.toISOString().slice(0, 10) : null, end: memberRange.end ? memberRange.end.toISOString().slice(0, 10) : null },
          effectiveStart: startDate ? startDate.toISOString().slice(0, 10) : null,
          effectiveEnd: endDate ? endDate.toISOString().slice(0, 10) : null,
          params
        });

        // Prefer calling the backend task-specific aggregation if available
        try {
          const teamRes = await stageAPI.getTeamStageDealCount(params);
          const apiData = teamRes?.data || teamRes;
          if (Array.isArray(apiData) && apiData.length > 0) {
            const normalized = apiData.map((item) => ({
              memberId: item.memberId || item.id || item._id || item.userId,
              memberName: item.memberName || item.name || item.userName || item.member_name || 'Unknown',
              email: item.email || item.memberEmail || null,
              stages: item.stages || {},
              // preserve any stageDetails if backend provides them so we can derive createdAt
              stageDetails: item.stageDetails || item.stage_details || {},
              // carry teamType directly from the API response
              teamType: item.teamType || null,
            }));

            const final = normalized.map((r) => {
              const found = (members || []).find((m) => String(m.id) === String(r.memberId));
              const merged = found ? { ...r, memberName: found.name || r.memberName } : r;

              // derive a fallback createdAt from any stageDetails available (earliest item createdAt)
              let createdAt = null;
              try {
                const detailValues = Object.values(merged.stageDetails || {});
                const allItems = Array.isArray(detailValues) ? detailValues.flat() : detailValues.flat ? detailValues.flat() : [];
                const dates = allItems
                  .map((d) => d && d.createdAt)
                  .filter(Boolean)
                  .map((dt) => new Date(dt).getTime())
                  .filter((t) => !isNaN(t));
                if (dates.length) {
                  const minTs = Math.min(...dates);
                  createdAt = new Date(minTs).toISOString();
                }
              } catch (e) {
                createdAt = null;
              }

              return { ...merged, createdAt: merged.createdAt || createdAt || null };
            });

            setStageDealData(final);
            return;
          }
        } catch (e) {
          // ignore and fall back to manager pipeline summary
          console.debug('getTeamStageDealCount not available, falling back:', e?.message || e);
        }

        console.log("📤 Fallback to getManagerPipelineSummary with params:", params);
        const res = await stageAPI.getManagerPipelineSummary(params);
        const stageDetails = res?.stageDetails || [];

        if (!stageDetails || stageDetails.length === 0) {
          setStageDealData([]);
          return;
        }

        // ownerMap -> { [ownerId]: { memberName, stages: { [stageName]: count } } }
        const ownerMap = {};

        const pushOwnerCount = (ownerId, ownerName, stageName, createdAt) => {
          if (!ownerId) return;
          const idStr = String(ownerId);
          if (!ownerMap[idStr]) ownerMap[idStr] = { memberName: ownerName || 'Unknown', stages: {} };
          ownerMap[idStr].stages[stageName] = (ownerMap[idStr].stages[stageName] || 0) + 1;
          if (createdAt) {
            try {
              const ts = new Date(createdAt).getTime();
              if (!isNaN(ts)) {
                // keep earliest createdAt seen for this owner
                if (!ownerMap[idStr].createdAtTs || ts < ownerMap[idStr].createdAtTs) {
                  ownerMap[idStr].createdAtTs = ts;
                  ownerMap[idStr].createdAt = new Date(ts).toISOString();
                }
              }
            } catch (e) {
              // ignore bad dates
            }
            // also collect deal dates array
            try {
              if (!ownerMap[idStr].dealDates) ownerMap[idStr].dealDates = [];
              ownerMap[idStr].dealDates.push(createdAt);
            } catch (e) { }
          }
        };

        stageDetails.forEach((stage) => {
          const stageName = stage.stageName || stage.name || "Unknown";

          // Items may be present under different keys depending on backend shape
          const dealsArr = (stage.items && stage.items.deals) || stage.deals || [];
          const leadsArr = (stage.items && stage.items.leads) || stage.leads || [];

          const allItems = Array.isArray(dealsArr) ? dealsArr.concat(Array.isArray(leadsArr) ? leadsArr : []) : Array.isArray(leadsArr) ? leadsArr : [];

          allItems.forEach((it) => {
            // prefer assignedTo, fallback to createdBy or parentUserId
            const owner = it?.assignedTo || it?.createdBy || it?.parentUserId || null;
            const ownerName = it?.assignedToName || it?.createdByName || it?.managerName || it?.userName || null;
            if (owner) pushOwnerCount(owner, ownerName, stageName, it?.createdAt || it?.created_at || null);
          });
        });

        // Convert map to array shape expected by UI
        const result = Object.keys(ownerMap).map((ownerId) => ({
          memberId: ownerId,
          memberName: ownerMap[ownerId].memberName,
          stages: ownerMap[ownerId].stages,
          createdAt: ownerMap[ownerId].createdAt || null,
          dealDates: ownerMap[ownerId].dealDates || [],
        }));

        // If we have members list, prefer member names from members state
        const final = result.map((r) => {
          const found = (members || []).find((m) => String(m.id) === String(r.memberId));
          return found ? { ...r, memberName: found.name || r.memberName } : r;
        });

        setStageDealData(final);
      } catch (err) {
        console.error('Failed to fetch stage-summary for team:', err);
        setStageDealData([]);
      }
    };
    fetchStageDealCount();
  }, [members, memberDateRange, memberCustomStart, memberCustomEnd, dateRange, customStart, customEnd]);

  // derive global ordered stage names (fall back to funnel labels)
  const globalStageNames =
    stageDealData.length > 0
      ? Object.keys(stageDealData[0].stages)
      : funnelChartState.labels?.length
        ? funnelChartState.labels
        : [];

  // create a consistent color map per stage name
  const stageColorMap = {};
  (globalStageNames || []).forEach((name, i) => {
    stageColorMap[name] = `rgba(${100 + ((i * 40) % 155)}, ${50 + ((i * 60) % 155)}, ${150 + ((i * 30) % 105)}, 0.85)`;
  });

  // Compute client-side filtered stageDealData using effective date range
  const computeRange = (rangeVal, sVal, eVal) => {
    const now = new Date();
    let s = null;
    let e = now;
    if (rangeVal && rangeVal !== "" && rangeVal !== "custom") {
      const days = Number(rangeVal);
      if (!isNaN(days) && days > 0) {
        e = new Date(now);
        s = new Date(now);
        s.setDate(e.getDate() - days);
      }
    } else if (rangeVal === "custom" && sVal && eVal) {
      s = new Date(sVal);
      e = new Date(eVal);
      e.setHours(23, 59, 59, 999);
    }
    return { start: s, end: e };
  };

  const globalRange = computeRange(dateRange, customStart, customEnd);
  const memberRange = computeRange(memberDateRange, memberCustomStart, memberCustomEnd);

  const pickStart = (a, b) => {
    if (!a && !b) return null;
    if (!a) return b;
    if (!b) return a;
    return a.getTime() > b.getTime() ? a : b;
  };
  const pickEnd = (a, b) => {
    if (!a && !b) return null;
    if (!a) return b;
    if (!b) return a;
    return a.getTime() < b.getTime() ? a : b;
  };

  const effectiveStart = pickStart(globalRange.start, memberRange.start);
  const effectiveEnd = pickEnd(globalRange.end, memberRange.end) || new Date();

  const stageDealDataFiltered = (stageDealData && stageDealData.length > 0)
    ? stageDealData.filter((m) => {
      let candidateDates = [];
      if (Array.isArray(m.dealDates) && m.dealDates.length) candidateDates = candidateDates.concat(m.dealDates);

      if (m.stageDetails && typeof m.stageDetails === "object") {
        const vals = Object.values(m.stageDetails || {});
        vals.forEach((arr) => {
          if (Array.isArray(arr)) {
            arr.forEach((it) => {
              if (it) {
                const dt = it.createdAt || it.created_at;
                if (dt) candidateDates.push(dt);
              }
            });
          }
        });
      }

      if (!candidateDates.length && m.createdAt) candidateDates.push(m.createdAt);

      // If no effective date filter is applied, include all
      if (!effectiveStart && !globalRange.start && !memberRange.start && !globalRange.end && !memberRange.end) return true;

      if (!candidateDates.length) return false;

      const rs = effectiveStart || null;
      const re = effectiveEnd || new Date();

      const anyInRange = candidateDates.some((dt) => {
        try {
          const t = new Date(dt).getTime();
          if (isNaN(t)) return false;
          if (rs && t < rs.getTime()) return false;
          if (re && t > re.getTime()) return false;
          return true;
        } catch (e) {
          return false;
        }
      });

      return anyInRange;
    })
    : [];

  // chartData removed (was unused) - stageDealData is available in `stageDealData` state

  const openStageForIndex = async (idx) => {
    if (idx === null || idx === undefined) return;
    // Use the sync ref (not the async state) to check if modal is already open
    if (!stageModalOpenRef.current) {
      if (stageOpeningRef.current) return; // prevent double-open from chart click + hover tooltip
      stageOpeningRef.current = true;
      setTimeout(() => { stageOpeningRef.current = false; }, 800);
    }
    const stageLabel = funnelChartState.labels[idx];
    setSelectedStage(stageLabel);

    // Get stageId from the funnel chart dataset
    const stageId = funnelChartState.datasets[0]?.stageIds?.[idx] || stageNameToId[stageLabel] || null;

    if (!stageId) {
      console.error("No stageId found for:", stageLabel);
      return;
    }

    setSelectedStageId(stageId);

    // Call backend API to get user-wise detail for the stage (use stageAPI)
    try {
      const res = await stageAPI.getStageUserWiseDetail(stageId);
      const userData = res?.data || [];

      if (userData.length > 0) {
        const labels = userData.map(u => u.userName || 'Unknown');
        const actualValues = userData.map(u => u.total || 0);
        const userIds = userData.map(u => u.userId);
        const colors = userData.map((_, i) =>
          `rgba(${100 + ((i * 40) % 155)}, ${50 + ((i * 60) % 155)}, ${150 + ((i * 30) % 105)}, 0.85)`
        );

        setStageUserChartData({
          labels,
          datasets: [
            {
              label: `Items in "${stageLabel}" by user`,
              data: actualValues,
              actualValues: actualValues,
              userIds: userIds,
              backgroundColor: colors,
              borderWidth: 0,
              barThickness: 24
            },
          ],
        });
      } else {
        setStageUserChartData({ labels: [], datasets: [] });
      }
    } catch (err) {
      console.error("Failed to fetch stage-user-wise detail:", err);
      setStageUserChartData({ labels: [], datasets: [] });
    }

    setOpenStageModal(true);
    stageModalOpenRef.current = true;
  };

  const openUserLineForName = async (userName, userId) => {
    if (!userName || !selectedStage || !selectedStageId) return;
    setSelectedUserForLine(userName);

    // Fetch user-stage items from API
    try {
      const res = await stageAPI.getUserStageItems(selectedStageId, userId);
      const items = res?.items || res?.data || [];

      if (items.length > 0) {
        setUserStageItems(items);
      } else {
        setUserStageItems([]);
      }
    } catch (err) {
      console.error("Failed to fetch user stage items:", err);
      setUserStageItems([]);
    }

    setOpenUserLineModal(true);
  };

  const handleStageUserClick = async (event, elements, chart) => {
    const native = event?.nativeEvent || event;
    let idx = elements && elements.length > 0 ? elements[0].index : null;
    let targetChart = chart;

    if (
      (idx === null || idx === undefined) &&
      !targetChart &&
      stageUserChartRef.current
    ) {
      targetChart =
        stageUserChartRef.current.chart || stageUserChartRef.current;
    }

    try {
      if (
        (idx === null || idx === undefined) &&
        targetChart &&
        typeof targetChart.getElementsAtEventForMode === "function"
      ) {
        const pts = targetChart.getElementsAtEventForMode(
          native,
          "nearest",
          { intersect: true },
          false
        );
        if (pts && pts.length > 0) idx = pts[0].index;
      }
    } catch (err) {
      console.error("stage-user click hit-test error:", err);
    }

    if (idx === null || idx === undefined) return;
    const userName = stageUserChartData.labels && stageUserChartData.labels[idx];
    const userId = stageUserChartData.datasets[0]?.userIds?.[idx];
    if (userName && userId) await openUserLineForName(userName, userId);
  };

  const handleFunnelClick = (event, elements, chart) => {
    const native = event?.nativeEvent || event;
    let idx = elements && elements.length > 0 ? elements[0].index : null;
    let targetChart = chart;

    if (!targetChart && funnelRef.current) {
      targetChart = funnelRef.current.chart || funnelRef.current;
    }

    try {
      if ((idx === null || idx === undefined) && targetChart) {
        if (typeof targetChart.getElementsAtEventForMode === "function") {
          const pts = targetChart.getElementsAtEventForMode(
            native,
            "nearest",
            { intersect: true },
            false
          );
          if (pts && pts.length > 0) idx = pts[0].index;
        }
      }
    } catch (err) {
      console.error("Error during hit-testing fallback:", err);
    }

    if (idx === null || idx === undefined) return;
    openStageForIndex(idx);
  };

  const handleFunnelHover = (event, elements) => {
    if (elements && elements.length > 0) {
      const idx = elements[0].index;
      setHoveredIndex(idx);
      const canvasRect = funnelRef.current?.canvas?.getBoundingClientRect();
      if (event?.native && canvasRect) {
        setHoverPos({
          x: event.native.clientX - canvasRect.left,
          y: event.native.clientY - canvasRect.top,
        });
      } else {
        setHoverPos({ x: 10, y: 10 });
      }
      setShowStageAction(true);
    } else {
      setShowStageAction(false);
      setHoveredIndex(null);
    }
  };

  // multi-line chart computation removed (unused)

  // Handler to open Task Detail modal
  const handleOpenTaskDetail = (task) => {
    setSelectedTask(task);
    setOpenTaskDetailModal(true);
  };

  // Handler to close Task Detail modal
  const handleCloseTaskDetail = () => {
    setOpenTaskDetailModal(false);
    setSelectedTask(null);
  };

  return (
    <div style={ { padding: '8px 0 12px 0', overflowX: 'hidden', minHeight: '100vh', backgroundColor: '#fff', width: '100%', boxSizing: 'border-box' } }>
      <div style={ { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, minHeight: '40px', flexWrap: 'wrap', gap: 12 } }>
        <h1 style={ { margin: '0', fontSize: '28px', fontWeight: 600, color: '#1a1a1a' } }>Manager Dashboard</h1>
        <div style={ { display: 'flex', alignItems: 'center', gap: 12 } }>
          <CustomFilterBar
            dateRange={ dateRange }
            setDateRange={ setDateRange }
            customStart={ customStart }
            setCustomStart={ setCustomStart }
            customEnd={ customEnd }
            setCustomEnd={ setCustomEnd }
            DATE_OPTIONS={ DATE_OPTIONS }
            STATUS_OPTIONS={ [] }
            dateLabel="Global Date-Range"
          />
        </div>
      </div>
      <div
        style={ {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(min(320px, 100%), 1fr))",
          gap: 20,
          marginBottom: 32,
        } }
      >
        {/* first graph */}
        <div style={ { border: "1px solid #e0e0e0", borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', backgroundColor: '#fff' } }>
          <div
            style={ {
              background: "#fff",
              borderRadius: 12,
              padding: 20,
              height: 320,
              boxSizing: "border-box",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              width: "100%",
            } }
          >
            <div
              style={ {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              } }
            >
              <h3 style={ { margin: 0 } }>Overall Lead Funnel</h3>
              <div style={ { display: "flex", gap: 6, alignItems: "center" } }>
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ (e) => setFunnelAnchor(e.currentTarget) }
                  aria-label="date-filter"
                  title="Filter by date range"
                >
                  <CalendarTodayIcon fontSize="small" />
                </IconButton>
                <ChartDateFilter
                  value={ funnelDateRange }
                  onChange={ setFunnelDateRange }
                  anchorEl={ funnelAnchor }
                  setAnchorEl={ setFunnelAnchor }
                  menuId="funnel-date-menu"
                />
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ () =>
                    downloadChartCSV(funnelChartState, {
                      filename: "overall_lead_funnel.csv",
                      includeAllDatasets: true,
                    })
                  }
                  aria-label="download-funnel-csv"
                  title="Download CSV"
                >
                  <DownloadIcon fontSize="small" />
                </IconButton>
              </div>
            </div>

            <div
              style={ {
                position: "relative",
                flex: 1,
                minHeight: 0,
                marginTop: 8,
                overflowY: "auto",
                overflowX: "hidden",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              } }
              className="funnel-scroll-container"
            >
              <style>
                { `
                  .funnel-scroll-container::-webkit-scrollbar {
                    display: none;
                  }
                `}
              </style>
              <div style={ { height: Math.max(200, (funnelChartState.labels?.length || 0) * 28), minHeight: "100%" } }>
                <Bar
                  ref={ funnelRef }
                  key={ `funnel-${funnelChartState.labels?.length || 0}` }
                  data={ funnelChartState }
                  options={ { ...funnelChartOptions, maintainAspectRatio: false } }
                  onClick={ (e, el, chart) => handleFunnelClick(e, el, chart) }
                  onHover={ (e, el) => handleFunnelHover(e, el) }
                />
              </div>
              { showStageAction && hoveredIndex !== null && (
                <div
                  style={ {
                    position: "absolute",
                    left: Math.max(8, hoverPos.x - 36),
                    top: Math.max(8, hoverPos.y - 28),
                    zIndex: 40,
                    background: "#fff",
                    borderRadius: 6,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                    padding: "6px 8px",
                    display: "flex",
                    gap: 8,
                    alignItems: "center",
                    pointerEvents: "none",
                    fontSize: 12,
                  } }
                  title="Click bar to view team"
                >
                  <span style={ { fontWeight: 600 } }>View team</span>
                </div>
              ) }
            </div>
          </div>
        </div>

        <Dialog
          open={ openStageModal }
          onClose={ () => { setOpenStageModal(false); stageModalOpenRef.current = false; } }
          maxWidth="md"
          fullWidth
        >
          <div
            style={ {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              borderBottom: "1px solid #e0e0e0"
            } }
          >
            <strong>
              { selectedStage
                ? `Leads in "${selectedStage}" — by user`
                : "Stage breakdown" }
            </strong>
            <div style={ { display: "flex", gap: 8, alignItems: "center" } }>
              <Button
                size="small"
                variant="outlined"
                onClick={ () => { setOpenStageModal(false); stageModalOpenRef.current = false; } }
                style={ { textTransform: "none", marginRight: 8 } }
              >
                Back
              </Button>
              <IconButton
                size="small"
                onClick={ () =>
                  downloadChartCSV(stageUserChartData, {
                    filename: `${selectedStage || "stage"}_by_user.csv`,
                    includeAllDatasets: true,
                  })
                }
                aria-label="download-stage-csv"
                title="Download CSV"
              >
                <DownloadIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                onClick={ () => { setOpenStageModal(false); stageModalOpenRef.current = false; } }
                aria-label="close-stage"
                title="Close"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </div>
          </div>
          { funnelChartState.labels && funnelChartState.labels.length > 0 && (
            <div style={ { padding: "12px 16px", backgroundColor: "#f8f9fa" } }>
              <div style={ { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" } }>
                <span style={ { fontSize: "12px", fontWeight: 600, color: "#666", marginRight: 8 } }>Switch Stage:</span>
                { funnelChartState.labels.map((stage, idx) => (
                  <button
                    key={ idx }
                    onClick={ () => openStageForIndex(idx) }
                    style={ {
                      padding: "6px 12px",
                      fontSize: "12px",
                      fontWeight: 500,
                      border: "1px solid #e0e0e0",
                      borderRadius: 16,
                      backgroundColor: selectedStage === stage ? "#1976d2" : "#fff",
                      color: selectedStage === stage ? "#fff" : "#666",
                      cursor: "pointer",
                      transition: "all 0.2s",
                      whiteSpace: "nowrap"
                    } }
                    onMouseEnter={ (e) => {
                      if (selectedStage !== stage) {
                        e.target.style.backgroundColor = "#f5f5f5";
                        e.target.style.borderColor = "#1976d2";
                      }
                    } }
                    onMouseLeave={ (e) => {
                      if (selectedStage !== stage) {
                        e.target.style.backgroundColor = "#fff";
                        e.target.style.borderColor = "#e0e0e0";
                      }
                    } }
                  >
                    { stage }
                  </button>
                )) }
              </div>
            </div>
          ) }
          <DialogContent dividers style={ { height: 420 } }>
            { stageUserChartData.labels &&
              stageUserChartData.labels.length > 0 ? (
              <Bar
                ref={ stageUserChartRef }
                key={ `stage-user-${selectedStage || "none"}-${stageUserChartData.labels?.length || 0
                  }` }
                data={ stageUserChartData }
                options={ stageUserChartOptions }
                onClick={ (e, el, chart) => handleStageUserClick(e, el, chart) }
              />
            ) : (
              <div style={ { padding: 24 } }>No leads found for this stage.</div>
            ) }
          </DialogContent>
        </Dialog>

        <div style={ { border: "1px solid #e0e0e0", borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', backgroundColor: '#fff' } }>
          {/*  Second graph */ }
          <div
            style={ {
              background: "#fff",
              borderRadius: 12,
              padding: 20,
              height: 320,
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box",
              justifyContent: "center",
              alignItems: "stretch",
            } }
          >
            <div
              style={ {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 1,
              } }
            >
              <h3 style={ { margin: 0 } }>Leads by Source</h3>
              <div style={ { display: "flex", alignItems: "center", gap: 6 } }>
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ (e) => setSourcesAnchor(e.currentTarget) }
                  aria-label="date-filter"
                  title="Filter by date range"
                >
                  <CalendarTodayIcon fontSize="small" />
                </IconButton>
                <ChartDateFilter
                  value={ sourcesDateRange }
                  onChange={ setSourcesDateRange }
                  anchorEl={ sourcesAnchor }
                  setAnchorEl={ setSourcesAnchor }
                  menuId="sources-date-menu"
                />
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ () =>
                    downloadChartCSV(sourcesChartData, {
                      filename: "leads_by_source.csv",
                      includeAllDatasets: true,
                    })
                  }
                  aria-label="download-csv"
                  title="Download CSV"
                >
                  <DownloadIcon fontSize="small" />
                </IconButton>

                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ () => setOpenSourcesModal(true) }
                  aria-label="expand-chart"
                  title="Expand chart"
                >
                  <FullscreenIcon fontSize="small" />
                </IconButton>
              </div>
            </div>
            <div style={ { height: "calc(100% - 36px)", width: "100%", position: "relative" } }>
              <Bar
                key={ `sources-${sourcesChartData.labels?.length || 0}` }
                data={ sourcesChartData }
                options={ { ...sourcesChartOptions, maintainAspectRatio: false } }
              />
              { (!sourcesChartData.labels || sourcesChartData.labels.length === 0) && (
                <div style={ {
                  position: "absolute",
                  top: 0, left: 0, right: 0, bottom: 0,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  pointerEvents: "none", background: "rgba(255,255,255,0.1)"
                } }>
                  <span style={ { color: "#999", fontSize: "14px" } }>
                    { isSourcesLoaded ? "No data available" : "Loading lead source data..." }
                  </span>
                </div>
              ) }
            </div>

            <Dialog
              open={ openSourcesModal }
              onClose={ () => setOpenSourcesModal(false) }
              maxWidth="lg"
              fullWidth
            >
              <DialogTitle
                style={ {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingRight: 8,
                } }
              >
                <span>Leads by Source — Full view</span>
                <div style={ { display: "flex", gap: 8, alignItems: "center" } }>
                  <IconButton
                    size="small"
                    sx={ { padding: "4px" } }
                    onClick={ (e) => setSourcesAnchor(e.currentTarget) }
                    aria-label="date-filter"
                    title="Filter by date range"
                  >
                    <CalendarTodayIcon fontSize="small" />
                  </IconButton>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={ () => setOpenSourcesModal(false) }
                    style={ { textTransform: "none", marginRight: 8 } }
                  >
                    Back
                  </Button>
                  <IconButton
                    size="small"
                    onClick={ () =>
                      downloadChartCSV(sourcesChartData, {
                        filename: "leads_by_source_full.csv",
                        includeAllDatasets: true,
                      })
                    }
                    aria-label="download-csv-full"
                    title="Download CSV"
                  >
                    <DownloadIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={ () => setOpenSourcesModal(false) }
                    aria-label="close"
                    title="Close"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </div>
              </DialogTitle>

              <DialogContent dividers style={ { height: 520, position: "relative" } }>
                <Bar
                  data={ sourcesChartData }
                  options={ {
                    ...sourcesChartOptions,
                    maintainAspectRatio: false,
                  } }
                />
                { (!sourcesChartData.labels || sourcesChartData.labels.length === 0) && (
                  <div style={ {
                    position: "absolute",
                    top: 0, left: 0, right: 0, bottom: 0,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    pointerEvents: "none", background: "rgba(255,255,255,0.1)"
                  } }>
                    <span style={ { color: "#999", fontSize: "14px" } }>
                      { isSourcesLoaded ? "No data available" : "Loading lead source data..." }
                    </span>
                  </div>
                ) }
              </DialogContent>
            </Dialog>
          </div>
        </div>

        {/* 3rd part: Placeholder */}
        <div style={ { border: "1px solid #e0e0e0", borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', backgroundColor: '#fff' } }>
          <div
            style={ {
              background: "#fff",
              borderRadius: 12,
              padding: 20,
              height: 320,
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box",
            } }
          >
            <div
              style={ {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 8,
              } }
            >
              <h3 style={ { margin: 0 } }>Team Tasks — Summary</h3>
              <div style={ { display: "flex", gap: 6, alignItems: "center" } }>
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ (e) => setTasksAnchor(e.currentTarget) }
                  aria-label="date-filter"
                  title="Filter by date range"
                >
                  <CalendarTodayIcon fontSize="small" />
                </IconButton>
                <ChartDateFilter
                  value={ tasksDateRange }
                  onChange={ setTasksDateRange }
                  anchorEl={ tasksAnchor }
                  setAnchorEl={ setTasksAnchor }
                  menuId="tasks-date-menu"
                />
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ () =>
                    downloadChartCSV(tasksChartData, {
                      filename: "team_tasks_summary.csv",
                      includeAllDatasets: true,
                    })
                  }
                  aria-label="download-tasks-csv"
                  title="Download CSV"
                >
                  <DownloadIcon fontSize="small" />
                </IconButton>

                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ () => setOpenTasksModal(true) }
                  aria-label="expand-tasks-chart"
                  title="Expand chart"
                >
                  <FullscreenIcon fontSize="small" />
                </IconButton>

              </div>
            </div>

            <div style={ { flex: 1, minHeight: 0 } }>
              <Bar
                data={ tasksChartData }
                options={ {
                  ...tasksChartOptions,
                  maintainAspectRatio: false,
                  onClick: (event, elements, chart) => {
                    if (elements && elements.length > 0) {
                      const idx = elements[0].index;
                      const user = currentTeamTasks[idx];
                      if (user && user.id) {
                        // Prefer the full member object (from members state) so MemberStageRing
                        // has access to `stages` and other fields. Fall back to a normalized
                        // object built from the task-summary entry when not available.
                        const fullMember = members.find((m) => m.id === user.id);

                        const memberForState = fullMember || {
                          id: user.id,
                          name: user.user_name || user.name || user.memberName || "",
                          contact: user.contact || null,
                          email: user.email || (user.contact && user.contact.email) || null,
                          _source: user._source || "taskSummary",
                        };

                        const safeContact = memberForState.contact || null;
                        const safeEmail = safeContact?.email || memberForState.email || null;

                        navigate(`/home/member/${user.id}`, {
                          state: {
                            fromTaskGraph: true,
                            from: 'manager-dashboard',
                            member: memberForState,
                            tasks: user.tasks || [],
                            safeContact,
                            safeEmail,
                          },
                        });
                      }
                    }
                  },
                  plugins: {
                    ...tasksChartOptions.plugins,
                    legend: tasksChartOptions.plugins.legend,
                    tooltip: tasksChartOptions.plugins.tooltip,
                  },
                } }
              />
            </div>

            {/* Tabs for Fullscreen Team Tasks */}
            <Dialog
              open={ openTasksModal }
              onClose={ () => {
                setOpenTasksModal(false);
                setTasksTab(0);
              } }
              maxWidth="lg"
              fullWidth
            >
              <DialogTitle
                style={ {
                  display: "block",
                  paddingRight: 8,
                  paddingBottom: 0,
                } }
              >
                <div style={ { display: "flex", alignItems: "center", gap: 12, marginBottom: 0 } }>
                  <span style={ { fontWeight: 600, fontSize: 18, marginRight: 16 } }>Team Tasks</span>
                  <Tabs
                    value={ tasksTab }
                    onChange={ (e, newValue) => {
                      setTasksTab(newValue);
                      if (newValue === 1) {
                        setOpenTasksModal(false);
                        setTasksTab(0);
                        // Instead of navigating, open Task Detail modal (show first task as example)
                        if (currentTeamTasks.length > 0 && Array.isArray(currentTeamTasks[0].in_progress_tasks) && currentTeamTasks[0].in_progress_tasks.length > 0) {
                          handleOpenTaskDetail(currentTeamTasks[0].in_progress_tasks[0]);
                        } else {
                          // fallback: just open modal with null
                          handleOpenTaskDetail(null);
                        }
                      }
                    } }
                    aria-label="team-tasks-tabs"
                    sx={ { minHeight: 0, height: 36 } }
                  >
                    <Tab label="Full View" sx={ { minHeight: 0, height: 36 } } />
                  </Tabs>
                  <div style={ { marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 } }>
                    <IconButton
                      size="small"
                      sx={ { padding: "4px" } }
                      onClick={ (e) => setTasksAnchor(e.currentTarget) }
                      aria-label="date-filter"
                      title="Filter by date range"
                    >
                      <CalendarTodayIcon fontSize="small" />
                    </IconButton>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={ () => {
                        setOpenTasksModal(false);
                        setTasksTab(0);
                      } }
                      style={ { textTransform: "none" } }
                    >
                      Back
                    </Button>
                    <IconButton
                      size="small"
                      onClick={ () =>
                        downloadChartCSV(tasksChartData, {
                          filename: "team_tasks_summary_full.csv",
                          includeAllDatasets: true,
                        })
                      }
                      aria-label="download-tasks-csv-full"
                      title="Download CSV"
                    >
                      <DownloadIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={ () => {
                        setOpenTasksModal(false);
                        setTasksTab(0);
                      } }
                      aria-label="close-tasks-full"
                      title="Close"
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </div>
                </div>
                <div style={ { borderBottom: '1px solid #e0e0e0', marginTop: 8 } } />
              </DialogTitle>
              <DialogContent dividers style={ { height: 520 } }>
                { tasksTab === 0 ? (
                  tasksChartData.labels && tasksChartData.labels.length > 0 ? (
                    <Bar
                      data={ tasksChartData }
                      options={ {
                        ...tasksChartOptions,
                        maintainAspectRatio: false,
                        onClick: (event, elements, chart) => {
                          if (elements && elements.length > 0) {
                            const idx = elements[0].index;
                            const user = currentTeamTasks[idx];
                            if (user && user.id) {
                              const fullMember = members.find((m) => m.id === user.id);
                              const memberForState = fullMember || {
                                id: user.id,
                                name: user.user_name || user.name || user.memberName || "",
                                contact: user.contact || null,
                                email: user.email || (user.contact && user.contact.email) || null,
                                _source: user._source || "taskSummary",
                              };
                              const safeContact = memberForState.contact || null;
                              const safeEmail = safeContact?.email || memberForState.email || null;
                              navigate(`/home/member/${user.id}`, {
                                state: {
                                  fromTaskGraph: true,
                                  from: 'manager-dashboard',
                                  member: memberForState,
                                  tasks: user.tasks || [],
                                  safeContact,
                                  safeEmail,
                                },
                              });
                            }
                          }
                        }
                      } }
                      height={ 480 }
                    />
                  ) : (
                    <div style={ { padding: 24, textAlign: 'center', color: '#999' } }>No task data available</div>
                  )
                ) : null }
              </DialogContent>
            </Dialog>
            {/* Task Detail Modal (Dialog) - renders TaskList as modal */}
            <Dialog
              open={ openTaskDetailModal }
              onClose={ handleCloseTaskDetail }
              maxWidth="lg"
              fullWidth
            >
              <DialogTitle
                style={ {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingRight: 8,
                } }
              >
                <span>Task Detail</span>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={ handleCloseTaskDetail }
                  style={ { textTransform: "none", marginRight: 8 } }
                >
                  Back
                </Button>
              </DialogTitle>
              <DialogContent dividers style={ { minHeight: 320 } }>
                <TaskList
                  task={ selectedTask }
                  onClose={ handleCloseTaskDetail }
                  fromManagerDashboard={ true }
                  members={ members }
                />
              </DialogContent>
            </Dialog>
          </div>
        </div>

        {/* 4th part :Placeholder */}
        <div style={ { border: "1px solid #e0e0e0", borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', backgroundColor: '#fff' } }>
          <div
            style={ {
              background: "#fff",
              borderRadius: 12,
              padding: 20,
              height: 320,
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box",
            } }
          >
            <div
              style={ {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 8,
              } }
            >
              <h3 style={ { margin: 0 } }>Team Performance</h3>
              <div style={ { display: "flex", gap: 6, alignItems: "center" } }>
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ (e) => setPerfAnchor(e.currentTarget) }
                  aria-label="date-filter"
                  title="Filter by date range"
                >
                  <CalendarTodayIcon fontSize="small" />
                </IconButton>
                <ChartDateFilter
                  value={ perfDateRange }
                  onChange={ setPerfDateRange }
                  anchorEl={ perfAnchor }
                  setAnchorEl={ setPerfAnchor }
                  menuId="perf-date-menu"
                />
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ () =>
                    downloadChartCSV(teamPerfData, {
                      filename: "team_performance.csv",
                      includeAllDatasets: true,
                    })
                  }
                  aria-label="download-team-perf-csv"
                  title="Download CSV"
                >
                  <DownloadIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ () => setOpenTeamPerfModal(true) }
                  aria-label="expand-team-perf-chart"
                  title="View Full"
                >
                  <FullscreenIcon fontSize="small" />
                </IconButton>
              </div>
            </div>
            <div style={ { flex: 1, minHeight: 0 } }>
              { teamPerfData.labels && teamPerfData.labels.length > 0 ? (
                <Bar
                  key={ `team-perf-${teamPerfData.labels.length}` }
                  data={ teamPerfData }
                  options={ { ...teamPerfChartOptions, maintainAspectRatio: false } }
                />
              ) : (
                <div style={ { padding: 24, textAlign: 'center', color: '#999' } }>No team performance data available</div>
              ) }
            </div>
            {/* Fullscreen Dialog for Team Performance */}
            <Dialog
              open={ openTeamPerfModal }
              onClose={ () => setOpenTeamPerfModal(false) }
              maxWidth="lg"
              fullWidth
            >
              <DialogTitle
                style={ {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingRight: 8,
                } }
              >
                <span>Team Performance — Full view</span>
                <div style={ { display: "flex", gap: 8, alignItems: "center" } }>
                  <IconButton
                    size="small"
                    sx={ { padding: "4px" } }
                    onClick={ (e) => setPerfAnchor(e.currentTarget) }
                    aria-label="date-filter"
                    title="Filter by date range"
                  >
                    <CalendarTodayIcon fontSize="small" />
                  </IconButton>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={ () => setOpenTeamPerfModal(false) }
                    style={ { textTransform: "none", marginRight: 8 } }
                  >
                    Back
                  </Button>
                  <IconButton
                    size="small"
                    onClick={ () =>
                      downloadChartCSV(teamPerfData, {
                        filename: "team_performance_full.csv",
                        includeAllDatasets: true,
                      })
                    }
                    aria-label="download-team-perf-csv-full"
                    title="Download CSV"
                  >
                    <DownloadIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={ () => setOpenTeamPerfModal(false) }
                    aria-label="close-team-perf"
                    title="Close"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </div>
              </DialogTitle>
              <DialogContent dividers style={ { height: 520 } }>
                { teamPerfData.labels && teamPerfData.labels.length > 0 ? (
                  <Bar
                    data={ teamPerfData }
                    options={ {
                      ...teamPerfChartOptions,
                      maintainAspectRatio: false,
                    } }
                    height={ 480 }
                  />
                ) : (
                  <div style={ { padding: 24, textAlign: 'center', color: '#999' } }>No team performance data available</div>
                ) }
              </DialogContent>
            </Dialog>
          </div>
        </div>

        {/* 5th graph: Top Customer Questions */ }
        <div style={ { border: "1px solid #e0e0e0", borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', backgroundColor: '#fff', position: 'relative', zIndex: 10 } }>
          <div style={ { background: "#fff", borderRadius: 12, padding: 20, height: 320, display: "flex", flexDirection: "column", boxSizing: "border-box", overflow: "visible" } }>
            <div style={ { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 } }>
              <h3 style={ { margin: 0 } }>Top Customer Questions</h3>
              <div style={ { display: "flex", gap: 6, alignItems: "center" } }>
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ (e) => setQuestionsAnchor(e.currentTarget) }
                  aria-label="date-filter"
                  title="Filter by date range"
                >
                  <CalendarTodayIcon fontSize="small" />
                </IconButton>
                <ChartDateFilter
                  value={ questionsDateRange }
                  onChange={ setQuestionsDateRange }
                  anchorEl={ questionsAnchor }
                  setAnchorEl={ setQuestionsAnchor }
                  menuId="questions-date-menu"
                />
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ () => downloadChartCSV(customerQuestionsData, { filename: "top_customer_questions.csv" }) }
                  aria-label="download-questions-csv"
                  title="Download CSV"
                >
                  <DownloadIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ () => setOpenQuestionsModal(true) }
                  aria-label="expand-questions-chart"
                  title="Expand chart"
                >
                  <FullscreenIcon fontSize="small" />
                </IconButton>
              </div>
            </div>
            {/* Scrollable chart area */ }
            <div style={ { flex: 1, minHeight: 0, overflowY: "auto", overflowX: "visible", scrollbarWidth: "none", msOverflowStyle: "none", clipPath: "none" } }>
              <style>{ `.questions-scroll::-webkit-scrollbar { display: none; }` }</style>
              <div
                className="questions-scroll"
                style={ { height: Math.max(200, customerQuestionsData.labels.length * 36), overflow: "visible", position: "relative", zIndex: 20 } }
              >
                {/* Hidden div used as the y-axis label hover tooltip */ }
                <div
                  ref={ questionsLabelTooltipRef }
                  style={ {
                    display: 'none',
                    position: 'fixed',
                    background: 'rgba(30,30,30,0.95)',
                    color: '#fff',
                    padding: '8px 12px',
                    borderRadius: 8,
                    fontSize: 13,
                    maxWidth: 480,
                    width: 'max-content',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    pointerEvents: 'none',
                    zIndex: 99999,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.35)',
                    lineHeight: 1.6,
                  } }
                />
                <Bar
                  ref={ questionsChartRef }
                  data={ {
                    ...customerQuestionsData,
                    labels: customerQuestionsData.labels.map((l) =>
                      l.length > 28 ? l.slice(0, 28) + '…' : l
                    ),
                    datasets: customerQuestionsData.datasets.map((ds) => ({
                      ...ds,
                      originalLabels: customerQuestionsData.labels,
                    })),
                  } }
                  options={ {
                    indexAxis: "y",
                    responsive: true,
                    maintainAspectRatio: false,
                    clip: false,
                    layout: { padding: { right: 8 } },
                    plugins: {
                      legend: { display: false },
                      tooltip: {
                        position: 'nearest',
                        callbacks: {
                          title: (items) => {
                            const ds = items[0]?.dataset;
                            const full = (ds?.originalLabels?.[items[0].dataIndex]) || customerQuestionsData.labels[items[0].dataIndex] || '';
                            // wrap long labels into ~40-char lines for the tooltip
                            const words = full.split(' ');
                            const lines = [];
                            let line = '';
                            words.forEach(w => {
                              if ((line + ' ' + w).trim().length > 40) { lines.push(line.trim()); line = w; }
                              else { line = (line + ' ' + w).trim(); }
                            });
                            if (line) lines.push(line);
                            return lines;
                          },
                          label: (ctx) => ` ${ctx.parsed.x} customer asked this`,
                        },
                      },
                    },
                    scales: {
                      x: {
                        beginAtZero: true,
                        title: { display: true, text: "Number of Customers →", font: { size: 12, weight: 'normal' }, color: "#666", padding: { top: 8, bottom: 4 } },
                        ticks: { stepSize: 1, font: { size: 11, weight: 'normal' }, maxTicksLimit: 6 },
                        grid: { color: "rgba(0,0,0,0.05)" },
                      },
                      y: {
                        title: { display: false },
                        ticks: {
                          font: { size: 11, weight: 'normal' },
                          crossAlign: 'far',
                          padding: 6,
                        },
                        grid: { display: false },
                        afterFit: (axis) => { axis.width = 170; },
                      },
                    },
                    elements: { bar: { borderRadius: 2, borderSkipped: false } },
                  } }
                  onMouseMove={ (e) => {
                    const chart = questionsChartRef.current;
                    if (!chart) return;
                    const canvas = chart.canvas;
                    if (!canvas) return;
                    const rect = canvas.getBoundingClientRect();
                    const mx = e.clientX - rect.left;
                    const my = e.clientY - rect.top;
                    const yAxis = chart.scales?.y;
                    const tip = questionsLabelTooltipRef.current;
                    if (!yAxis || !tip) return;

                    // y-axis label area is from x=0 to yAxis.left
                    if (mx >= 0 && mx <= yAxis.left) {
                      // find which tick the cursor is on
                      const ticks = yAxis.ticks || [];
                      let found = null;
                      for (let i = 0; i < ticks.length; i++) {
                        const py = yAxis.getPixelForTick(i);
                        if (Math.abs(my - py) < 14) { found = i; break; }
                      }
                      if (found !== null) {
                        const fullLabel = customerQuestionsData.labels[found] || '';
                        const truncated = fullLabel.length > 28 ? fullLabel.slice(0, 28) + '…' : fullLabel;
                        // only show tooltip if label is actually truncated
                        if (fullLabel !== truncated) {
                          tip.textContent = fullLabel;
                          tip.style.display = 'block';
                          // Position: prefer right of cursor, flip left if near right edge
                          const tipW = Math.min(480, fullLabel.length * 8 + 24);
                          const leftPos = e.clientX + 14 + tipW > window.innerWidth
                            ? e.clientX - tipW - 8
                            : e.clientX + 14;
                          tip.style.left = leftPos + 'px';
                          tip.style.top = (e.clientY - 14) + 'px';
                          return;
                        }
                      }
                    }
                    tip.style.display = 'none';
                  } }
                  onMouseLeave={ () => {
                    const tip = questionsLabelTooltipRef.current;
                    if (tip) tip.style.display = 'none';
                  } }
                />
              </div>
            </div>
          </div>

          {/* Wide view Dialog */ }
          <Dialog
            open={ openQuestionsModal }
            onClose={ () => setOpenQuestionsModal(false) }
            maxWidth="lg"
            fullWidth
          >
            <DialogTitle
              style={ { display: "flex", justifyContent: "space-between", alignItems: "center", paddingRight: 8 } }
            >
              <span>Top Customer Questions — Full view</span>
              <div style={ { display: "flex", gap: 8, alignItems: "center" } }>
                <IconButton
                  size="small"
                  sx={ { padding: "4px" } }
                  onClick={ (e) => setQuestionsAnchor(e.currentTarget) }
                  aria-label="date-filter"
                  title="Filter by date range"
                >
                  <CalendarTodayIcon fontSize="small" />
                </IconButton>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={ () => setOpenQuestionsModal(false) }
                  style={ { textTransform: "none", marginRight: 8 } }
                >
                  Back
                </Button>
                <IconButton
                  size="small"
                  onClick={ () => downloadChartCSV(customerQuestionsData, { filename: "top_customer_questions_full.csv" }) }
                  aria-label="download-questions-csv-full"
                  title="Download CSV"
                >
                  <DownloadIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={ () => setOpenQuestionsModal(false) }
                  aria-label="close-questions"
                  title="Close"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent dividers style={ { height: 520 } }>
              <Bar
                data={ {
                  ...customerQuestionsData,
                  labels: customerQuestionsData.labels.map((l) =>
                    l.length > 45 ? l.slice(0, 45) + '…' : l
                  ),
                } }
                options={ {
                  indexAxis: "y",
                  responsive: true,
                  maintainAspectRatio: false,
                  layout: { padding: { right: 12 } },
                  plugins: {
                    legend: { display: false },
                    tooltip: {
                      callbacks: {
                        title: (items) => {
                          const full = customerQuestionsData.labels[items[0].dataIndex] || '';
                          const words = full.split(' ');
                          const lines = [];
                          let line = '';
                          words.forEach(w => {
                            if ((line + ' ' + w).trim().length > 45) { lines.push(line.trim()); line = w; }
                            else { line = (line + ' ' + w).trim(); }
                          });
                          if (line) lines.push(line);
                          return lines;
                        },
                        label: (ctx) => ` ${ctx.parsed.x} customer asked this`,
                      },
                    },
                  },
                  scales: {
                    x: {
                      beginAtZero: true,
                      title: { display: true, text: "Number of Customers →", font: { size: 13, weight: 'normal' }, color: "#666", padding: { top: 10, bottom: 5 } },
                      ticks: { stepSize: 1, font: { size: 12, weight: 'normal' }, maxTicksLimit: 8 },
                      grid: { color: "rgba(0,0,0,0.05)" },
                    },
                    y: {
                      title: { display: false },
                      ticks: {
                        font: { size: 12, weight: 'normal' },
                        crossAlign: 'far',
                        padding: 8,
                      },
                      grid: { display: false },
                      afterFit: (axis) => { axis.width = 260; },
                    },
                  },
                  elements: { bar: { borderRadius: 2, borderSkipped: false } },
                } }
              />
            </DialogContent>
          </Dialog>
        </div>

      </div>

      {/* Tele Sales Report: rendered below graphs */}
      <div style={ { marginBottom: 20 } }>
        {/* <TeleSalesReport /> */}
      </div>

      {/* Member List */}
      { (() => {
        const displayMembers = (stageDealData && stageDealData.length > 0)
          ? stageDealData.map((m) => {
            // Try ID-based lookup first, then fall back to name-based match
            const byId = filteredMembers.find((fm) => String(fm.id) === String(m.memberId));
            const byName = !byId
              ? filteredMembers.find((fm) => (fm.name || '').toLowerCase() === (m.memberName || '').toLowerCase())
              : null;
            return {
              id: m.memberId,
              name: m.memberName,
              stages: m.stages,
              stageDetails: m.stageDetails,
              email: m.email,
              tasks: m.tasks || [],
            };
          })
          : filteredMembers;

        return (
          <>
            {/* Heading and Date Filter Row */}
            <div style={ { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 16, padding: "0 4px" } }>
              <h2 style={{ 
                margin: 0, 
                fontSize: '28px', 
                fontWeight: 600, 
                color: '#1a1a1a' 
              }}>
                Invited Members
              </h2>

              <div style={ { display: "flex", alignItems: "center", gap: 16 } }>
                <CustomFilterBar
                  dateRange={ memberDateRange }
                  setDateRange={ setMemberDateRange }
                  customStart={ memberCustomStart }
                  setCustomStart={ setMemberCustomStart }
                  customEnd={ memberCustomEnd }
                  setCustomEnd={ setMemberCustomEnd }
                  DATE_OPTIONS={ DATE_OPTIONS }
                  STATUS_OPTIONS={ [] }
                  dateLabel="Member Date-Range"
                />
              </div>
            </div>

            {/* Member List */}
            { displayMembers.length === 0 ? (
              <div style={ { textAlign: 'center', padding: '48px 0', color: '#9ca3af', fontSize: '14px' } }>
                No members found.
              </div>
            ) : (
              <div>
                {/* Horizontal scroll row for ring cards */}
                <div
                  className="team-scroll-row"
                  style={ {
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 20,
                    overflowX: 'auto',
                    overflowY: 'visible',
                    paddingTop: 30,
                    paddingBottom: 12,
                    paddingLeft: 8,
                    paddingRight: 8,
                    flexWrap: 'wrap',
                  } }
                >
                  { displayMembers.map((m) => (
                    <div
                      key={ m.id }
                      style={ {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        flexShrink: 0,
                        width: 260,
                      } }
                    >
                      <MemberStageRing
                        member={ m }
                        size={ 250 }
                        onClick={ () =>
                          navigate(`/home/member/${m.id}?userId=${m.id}`, {
                            state: {
                              from: 'manager-dashboard',
                              member: m,
                              tasks: m.tasks || [],
                              safeContact: m?.contact,
                              safeEmail: m?.contact?.email || m?.email,
                            },
                          })
                        }
                      />
                    </div>
                  )) }
                </div>
              </div>
            ) }
          </>
        );
      })() }

      <Dialog
        open={ openUserLineModal }
        onClose={ () => {
          setOpenUserLineModal(false);
          setSelectedUserForLine(null);
        } }
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          style={ {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingRight: 8,
          } }
        >
          <span>
            { selectedUserForLine
              ? `Items for ${selectedUserForLine}`
              : "Items" }
            { selectedStage ? ` in "${selectedStage}"` : "" }
          </span>
          <div style={ { display: "flex", gap: 8, alignItems: "center" } }>
            <Button
              size="small"
              variant="outlined"
              onClick={ () => {
                setOpenUserLineModal(false);
                setSelectedUserForLine(null);
                setUserStageItems([]);
              } }
              style={ { textTransform: "none", marginRight: 8 } }
            >
              Back
            </Button>
            <IconButton
              size="small"
              onClick={ () => {
                setOpenUserLineModal(false);
                setSelectedUserForLine(null);
                setUserStageItems([]);
              } }
              aria-label="close-user-line"
              title="Close"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers style={ { height: 560, padding: 16 } }>
          { userStageItems && userStageItems.length > 0 ? (
            <div style={ { height: "100%", overflowY: "auto" } }>
              <table style={ { width: "100%", borderCollapse: "collapse", fontSize: "14px" } }>
                <thead style={ { position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1 } }>
                  <tr>
                    <th style={ { padding: "12px 8px", textAlign: "left", borderBottom: "2px solid #e0e0e0", fontWeight: 600 } }>Deal Name</th>
                    <th style={ { padding: "12px 8px", textAlign: "left", borderBottom: "2px solid #e0e0e0", fontWeight: 600 } }>
                      Assigned By
                    </th>
                    <th style={ { padding: "12px 8px", textAlign: "left", borderBottom: "2px solid #e0e0e0", fontWeight: 600 } }>Assigned To</th>
                    <th style={ { padding: "12px 8px", textAlign: "left", borderBottom: "2px solid #e0e0e0", fontWeight: 600 } }>Created At</th>
                    <th style={ { padding: "12px 8px", textAlign: "left", borderBottom: "2px solid #e0e0e0", fontWeight: 600 } }>Assigned At</th>
                    <th style={ { padding: "12px 8px", textAlign: "left", borderBottom: "2px solid #e0e0e0", fontWeight: 600 } }>Updated At</th>
                  </tr>
                </thead>
                <tbody>
                  { userStageItems.map((item, idx) => (
                    <tr key={ item.id || idx } style={ { borderBottom: "1px solid #f0f0f0" } }>
                      <td style={ { padding: "12px 8px", fontWeight: 500 } }>{ item.name || "Unknown" }</td>
                      <td style={ { padding: "12px 8px", color: "#666" } }>{ item.managerName || "Unknown" }</td>
                      <td style={ { padding: "12px 8px", color: "#666" } }>{ item.assignedToName || "Unknown" }</td>
                      <td style={ { padding: "12px 8px", color: "#666" } }>{ item.createdAt || "-" }</td>
                      <td style={ { padding: "12px 8px", color: "#666" } }>{ item.assignedAt || "-" }</td>
                      <td style={ { padding: "12px 8px", color: "#666" } }>{ item.updatedAt || "-" }</td>
                    </tr>
                  )) }
                </tbody>
              </table>
            </div>
          ) : (
            <div style={ { padding: 24, textAlign: "center", color: "#999" } }>
              No items found for this user in this stage.
            </div>
          ) }
        </DialogContent>
      </Dialog>
    </div >
  );
}
